import * as e from "echarts";
import * as t from "react";
import { createContext as n, createElement as r, forwardRef as i, useCallback as a, useContext as o, useEffect as s, useImperativeHandle as c, useMemo as l, useRef as u, useState as d } from "react";
import { Fragment as f, jsx as p, jsxs as m } from "react/jsx-runtime";
import { columnOrderingFeature as h, columnPinningFeature as g, columnResizingFeature as _, columnSizingFeature as v, columnVisibilityFeature as y, createSortedRowModel as b, flexRender as x, metaHelper as S, rowSelectionFeature as C, rowSortingFeature as w, sortFn_alphanumeric as T, sortFn_basic as E, sortFn_datetime as D, sortFn_text as O, tableFeatures as k, useTable as ee } from "@tanstack/react-table";
import { flushSync as te } from "react-dom";
var A = new class {
	handlers = /* @__PURE__ */ new Map();
	publish(e, t) {
		let n = this.handlers.get(e);
		if (n) for (let r of n) try {
			r(t);
		} catch (t) {
			console.error(`[eventBus] handler for "${e}" threw`, t);
		}
	}
	subscribe(e, t) {
		let n = this.handlers.get(e);
		return n || (n = /* @__PURE__ */ new Set(), this.handlers.set(e, n)), n.add(t), () => this.unsubscribe(e, t);
	}
	unsubscribe(e, t) {
		let n = this.handlers.get(e);
		n && (n.delete(t), n.size === 0 && this.handlers.delete(e));
	}
	clear() {
		this.handlers.clear();
	}
}(), j = 12;
function M(e) {
	return e?.getZr?.()?.storage?.getDisplayList?.(!1) ?? [];
}
function ne(e) {
	let t = e.getBoundingRect?.();
	if (!t) return null;
	let n = -Infinity;
	if (e.transform && e.transform.length >= 6) {
		let [, r, , i, , a] = e.transform;
		for (let [e, o] of [
			[t.x, t.y],
			[t.x + t.width, t.y],
			[t.x, t.y + t.height],
			[t.x + t.width, t.y + t.height]
		]) {
			let t = r * e + i * o + a;
			t > n && (n = t);
		}
	} else {
		let r = e.y ?? 0, i = e.parent;
		for (; i;) r += i.y ?? 0, i = i.parent;
		n = r + t.y + t.height;
	}
	return Math.round(n);
}
function N(e) {
	let t = e?.getHeight?.();
	return typeof t == "number" ? t : null;
}
function re(e) {
	let t = e?.getOption?.(), n = (Array.isArray(t?.grid) ? t?.grid?.[0] : t?.grid)?.bottom, r = N(e);
	return typeof n != "number" || r === null ? null : r - n;
}
function ie(e) {
	let t = e, n = t?.getOption?.(), r = (Array.isArray(n?.dataZoom) ? n?.dataZoom : []).find((e) => typeof e == "object" && !!e && e.type === "slider" && e.show !== !1);
	if (!r) return null;
	let i = N(t);
	return i === null || typeof r.bottom != "number" || typeof r.height != "number" ? null : i - r.bottom - r.height;
}
function ae(e) {
	let [, t, n] = e.transform ?? [];
	return Math.abs(t ?? 0) > 1e-6 || Math.abs(n ?? 0) > 1e-6;
}
function oe(e, t) {
	let n = null, r = null;
	for (let i of M(e)) {
		let e = i, a = e.style?.text;
		if (typeof a != "string" || !t.includes(a) || e.transform && ae(e)) continue;
		let o = ne(e);
		if (o === null) continue;
		(r === null || o > r) && (r = o);
		let s = e.getBoundingRect?.(), c = s && e.transform && e.transform.length >= 6 ? (() => {
			let [, t, , n, , r] = e.transform, i = [[s.x, s.y], [s.x + s.width, s.y]], a = Infinity;
			for (let [e, o] of i) a = Math.min(a, t * e + n * o + r);
			return Math.round(a);
		})() : o - Math.round(s?.height ?? 16);
		(n === null || c < n) && (n = c);
	}
	return n !== null && r !== null ? {
		top: n,
		bottom: r
	} : null;
}
function se(e, t) {
	return oe(e, t)?.bottom ?? null;
}
function P(e) {
	let t = e, n = re(t);
	if (n === null) return null;
	let r = null;
	for (let e of M(t)) {
		let t = e;
		if (typeof t.style?.text != "string" || t.style.text === "") continue;
		let i = ne(t);
		i !== null && i > n + 1 && (r === null || i > r) && (r = i);
	}
	return r;
}
function ce(e, t = 12) {
	let n = e, r = P(n), i = re(n);
	if (r === null || i === null) return null;
	let a = r - i, o = ie(n);
	if (o === null) return Math.round(a + 8);
	let s = N(n);
	return s === null ? null : Math.round(s - o + t + a);
}
function F(e, t = 12) {
	let n = e, r = n?.getOption?.(), i = se(n, (Array.isArray(r?.series) ? r?.series : []).map((e) => typeof e == "object" && e ? e.name : void 0).filter((e) => typeof e == "string" && e !== ""));
	return {
		top: i === null ? null : i + t,
		bottom: ce(n, t)
	};
}
//#endregion
//#region src/echart/axisFit.ts
var le = 45, ue = 7;
function de({ categories: e, plotWidth: t, visibleCount: n = e.length, fontSize: r = 12, font: i = "12px sans-serif", labelMargin: a = 8, measureText: o }) {
	if (t <= 0 || e.length === 0) return {
		rotate: 0,
		interval: "auto"
	};
	let s = o ?? fe(i) ?? ((e) => e.length * ue), c = t / Math.max(1, Math.min(n, e.length)), l = e.reduce((e, t) => Math.max(e, s(String(t))), 0);
	if (l + a <= c) return {
		rotate: 0,
		interval: 0
	};
	let u = (l + r) * Math.SQRT1_2;
	return u + a <= c ? {
		rotate: 45,
		interval: 0
	} : {
		rotate: 45,
		interval: Math.ceil((u + a) / c) - 1
	};
}
function fe(e = "12px sans-serif") {
	if (typeof document > "u") return;
	let t = document.createElement("canvas").getContext("2d");
	if (t) return t.font = e, (e) => t.measureText(e).width;
}
function pe(e, t) {
	let n = e, r = n?.getOption?.(), i = Array.isArray(r?.xAxis) ? r?.xAxis?.[0] : r?.xAxis, a = i?.axisLabel;
	if (!i || i.type !== "category" || a?.show === !1) return null;
	let o = Array.isArray(i.data) ? i.data.filter((e) => e != null) : [];
	if (o.length === 0) return null;
	let s = Array.isArray(r?.dataZoom) ? r?.dataZoom : [], c = o.length;
	for (let e of s) {
		if (typeof e != "object" || !e) continue;
		let { start: t, end: n } = e;
		typeof t == "number" && typeof n == "number" && (c = Math.min(c, Math.max(1, Math.ceil((n - t) / 100 * o.length))));
	}
	let l = Array.isArray(r?.grid) ? r?.grid?.[0] : r?.grid, u = l?.left, d = l?.right, f = n?.getWidth?.();
	if (typeof u != "number" || typeof d != "number" || typeof f != "number") return null;
	let p = typeof a?.fontSize == "number" ? a.fontSize : 12, m = typeof a?.fontFamily == "string" ? a.fontFamily : "sans-serif";
	return de({
		categories: o,
		plotWidth: f - u - d,
		visibleCount: c,
		fontSize: p,
		font: `${p}px ${m}`,
		measureText: t
	});
}
//#endregion
//#region src/common/registry.ts
var I = /* @__PURE__ */ new Map(), L = {
	register(e, t) {
		if (typeof e != "string" || e.length === 0) throw Error("[registry] callback name must be a non-empty string");
		if (typeof t != "function") throw Error(`[registry] callback "${e}" must be a function`);
		I.set(e, t);
	},
	unregister(e) {
		return I.delete(e);
	},
	resolve(e) {
		return I.get(e);
	},
	resolveOrThrow(e) {
		let t = I.get(e);
		if (!t) throw Error(`[registry] callback "${e}" is not registered`);
		return t;
	},
	has(e) {
		return I.has(e);
	},
	names() {
		return [...I.keys()];
	},
	clear() {
		I.clear();
	}
}, R = "$callback";
function me(e) {
	return typeof e == "object" && !!e && !Array.isArray(e) && "$callback" in e && typeof e.$callback == "string" && Object.keys(e).length === 1;
}
function z(e) {
	if (Array.isArray(e)) return e.map((e) => z(e));
	if (me(e)) {
		let t = e[R];
		return L.resolveOrThrow(t);
	}
	if (typeof e == "object" && e) {
		let t = {};
		for (let [n, r] of Object.entries(e)) t[n] = z(r);
		return t;
	}
	return e;
}
//#endregion
//#region src/common/config.ts
function B(e) {
	return typeof e == "object" && !!e && !Array.isArray(e);
}
function V(e, t) {
	let n = { ...e };
	for (let [e, r] of Object.entries(t)) {
		if (r === void 0) continue;
		let t = n[e];
		n[e] = B(t) && B(r) ? V(t, r) : r;
	}
	return n;
}
function he({ defaults: e, preset: t, config: n }) {
	let r = { ...e };
	if (t) {
		if (!t || typeof t.options != "object" || t.options === null) throw Error("[config] preset must carry an `options` object");
		r = V(r, t.options);
	}
	return V(r, n);
}
function ge(e) {
	if (e == null) return {};
	if (typeof e != "object" || Array.isArray(e)) throw Error("[config] config must be an object");
	let t = {};
	for (let [n, r] of Object.entries(e)) r !== void 0 && (t[n] = r);
	return t;
}
function _e(e) {
	let t = [];
	if (e == null) return {
		valid: !0,
		errors: t
	};
	if (typeof e != "object" || Array.isArray(e)) return {
		valid: !1,
		errors: ["config must be an object"]
	};
	let n = e;
	return n.preset !== void 0 && typeof n.preset != "string" && t.push("`preset` must be a string"), ve(n, "$", t), {
		valid: t.length === 0,
		errors: t
	};
}
function ve(e, t, n) {
	if (Array.isArray(e)) {
		e.forEach((e, r) => ve(e, `${t}[${r}]`, n));
		return;
	}
	if (typeof e == "object" && e) {
		if ("$callback" in e) {
			let r = e;
			(Object.keys(r).length !== 1 || typeof r.$callback != "string") && n.push(`\`${t}\` must be exactly { $callback: string }, found ${JSON.stringify(r)}`);
			return;
		}
		for (let [r, i] of Object.entries(e)) ve(i, `${t}${t === "$" ? "" : "."}${r}`, n);
	}
}
var H = {
	bar: {
		seriesType: "bar",
		tooltip: { trigger: "axis" }
	},
	defaultBar: {
		seriesType: "bar",
		tooltip: { trigger: "axis" }
	},
	stackedBar: {
		seriesType: "bar",
		stack: "total",
		tooltip: { trigger: "axis" }
	},
	line: {
		seriesType: "line",
		smooth: !0,
		tooltip: { trigger: "axis" }
	},
	pie: {
		seriesType: "pie",
		tooltip: { trigger: "item" },
		legend: {
			orient: "vertical",
			left: "left"
		}
	},
	barLine: {
		seriesType: "bar",
		comboLine: !0,
		tooltip: { trigger: "axis" }
	},
	cmykColors: { colors: [
		"#00AABF",
		"#C62839",
		"#F2C14E",
		"#2B2D42"
	] },
	twentyColors: { colors: [
		"#5470C6",
		"#91CC75",
		"#FAC858",
		"#EE6666",
		"#73C0DE",
		"#3BA272",
		"#FC8452",
		"#9A60B9",
		"#EA7CCC",
		"#00AABF",
		"#C62839",
		"#F2C14E",
		"#2B2D42",
		"#4E8098",
		"#7B9E56",
		"#D16666",
		"#4A6FA5",
		"#846A9E",
		"#3E8989",
		"#B08968"
	] },
	horizontalScroll: { dataZoom: [{ type: "slider" }, { type: "inside" }] }
}, ye = {
	title: {
		left: "center",
		top: 4
	},
	legend: { top: 38 },
	grid: {
		left: 56,
		right: 24,
		top: 64,
		bottom: 48
	},
	tooltip: {
		trigger: "axis",
		confine: !0,
		backgroundColor: "#3c3f45",
		borderWidth: 0,
		textStyle: {
			color: "#ffffff",
			fontSize: 12
		}
	},
	animation: !1
};
function U(e) {
	return {
		fontSize: 12,
		...e
	};
}
function be(e) {
	return e ? {
		fontSize: 12,
		...e
	} : void 0;
}
var W = {
	brushSelect: !1,
	showDetail: !1,
	handleSize: "60%",
	handleStyle: { borderColor: "#5470c6" },
	moveHandleSize: 4,
	moveHandleStyle: {
		color: "#5470c6",
		borderColor: "#3d5aa8"
	},
	fillerColor: "rgba(84, 112, 198, 0.18)",
	dataBackground: {
		lineStyle: { color: "rgba(84, 112, 198, 0.4)" },
		areaStyle: { color: "rgba(84, 112, 198, 0.1)" }
	},
	selectedDataBackground: {
		lineStyle: { color: "#3d5aa8" },
		areaStyle: { color: "rgba(84, 112, 198, 0.25)" }
	},
	emphasis: {
		handleStyle: { borderColor: "#3d5aa8" },
		moveHandleStyle: { color: "#3d5aa8" }
	}
}, G = {
	zoomOnMouseWheel: !1,
	moveOnMouseWheel: !0
};
function K({ config: e, dataset: t }) {
	let n = ge(e), r = _e(n);
	if (!r.valid) throw Error(`[echart] invalid config: ${r.errors.join("; ")}`);
	let i = n.preset, a = null;
	if (i) {
		let e = H[i];
		if (!e) throw Error(`[echart] unknown preset "${i}"`);
		a = e;
	}
	return xe(z(he({
		defaults: ye,
		preset: a ? {
			name: i,
			options: a
		} : null,
		config: n
	})), t);
}
function xe(e, t) {
	let n = t.source ?? [], [r = "", ...i] = t.dimensions ?? Se(n), a = e.xAxis?.data ?? n.map((e) => e[r]) ?? [], o = we(e, n, r, i), s = o.some((e) => e?.type !== "pie"), c = {
		tooltip: e.tooltip,
		legend: e.legend,
		color: e.colors,
		series: o
	};
	if (e.animation !== void 0 && (c.animation = e.animation), s) {
		c.grid = e.grid;
		let t = e.xAxis?.type, n = q({
			type: t ?? "category",
			data: t === void 0 || t === "category" ? a : e.xAxis?.data,
			name: e.xAxis?.name,
			nameLocation: e.xAxis?.nameLocation,
			nameGap: e.xAxis?.nameGap,
			nameTextStyle: e.xAxis?.nameTextStyle,
			axisLabel: U(e.xAxis?.axisLabel),
			min: e.xAxis?.min,
			max: e.xAxis?.max,
			minInterval: e.xAxis?.minInterval,
			maxInterval: e.xAxis?.maxInterval,
			splitLine: e.xAxis?.splitLine,
			inverse: e.xAxis?.inverse
		}), r = Ce(e.yAxis, e.comboLine);
		e.horizontal ? (c.xAxis = r, c.yAxis = n) : (c.xAxis = n, c.yAxis = r);
		let i = Te(e, a.length, e.horizontal === !0);
		i && (c.dataZoom = i);
	}
	return e.title && (c.title = typeof e.title == "string" ? { text: e.title } : { ...e.title }), c;
}
function Se(e) {
	let t = e.find((e) => typeof e == "object" && !!e);
	return t ? Object.keys(t) : [];
}
function Ce(e, t) {
	return Array.isArray(e) ? e.map((e) => q({
		type: "value",
		...e,
		axisLabel: U(e?.axisLabel)
	})) : e ? q({
		type: "value",
		...e,
		axisLabel: U(e.axisLabel)
	}) : t ? [{ type: "value" }, { type: "value" }] : {
		type: "value",
		axisLabel: U(void 0)
	};
}
function we(e, t, n, r) {
	if (e.series?.length) return e.series.map((i) => {
		if (i.type === "custom") return q({
			type: "custom",
			name: i.name,
			color: i.color,
			data: i.data,
			renderItem: i.renderItem,
			encode: i.encode,
			clip: i.clip,
			emphasis: i.emphasis,
			blur: i.blur
		});
		let a = i.field ?? n, o = {
			type: i.type ?? e.seriesType ?? "bar",
			stack: i.stack ?? e.stack,
			smooth: i.smooth,
			yAxisIndex: i.yAxisIndex,
			color: i.color,
			colorBy: i.colorBy,
			barWidth: i.barWidth,
			barGap: i.barGap,
			label: be(i.label),
			labelLayout: i.labelLayout,
			labelLine: i.labelLine,
			itemStyle: i.itemStyle,
			showBackground: i.showBackground,
			backgroundStyle: i.backgroundStyle,
			symbol: i.symbol,
			symbolSize: i.symbolSize,
			emphasis: i.emphasis,
			blur: i.blur,
			radius: i.radius,
			center: i.center
		};
		return o.type === "pie" ? (o.data = t.map((e) => ({
			name: e[n],
			value: e[i.field ?? r[0] ?? n]
		})), delete o.stack, delete o.yAxisIndex, delete o.smooth, delete o.barWidth) : (o.name = i.name ?? a, o.data = t.map((e, t) => {
			let n = e[a], r = i.itemStyleByIndex?.(t, n);
			return r ? {
				value: n,
				itemStyle: r
			} : n;
		})), q(o);
	});
	if (e.seriesType === "pie") {
		let e = r[0] ?? n;
		return [{
			type: "pie",
			data: t.map((t) => ({
				name: String(t[n] ?? ""),
				value: t[e]
			}))
		}];
	}
	let i = !!e.yAxis;
	return r.map((n, a) => {
		let o = !!e.comboLine && a === r.length - 1 && r.length > 1;
		return q({
			name: n,
			type: o ? "line" : e.seriesType ?? "bar",
			stack: o ? void 0 : e.stack,
			smooth: o ? !0 : e.smooth,
			data: t.map((e) => e[n]),
			yAxisIndex: o && !i ? 1 : void 0
		});
	});
}
function q(e) {
	let t = {};
	for (let [n, r] of Object.entries(e)) r !== void 0 && (t[n] = r);
	return t;
}
function Te(e, t, n = !1) {
	let r = e.dataZoom, i = n ? { yAxisIndex: 0 } : {}, a = Ee(r) && typeof r.edgeOffset == "number" ? r.edgeOffset : 4, o = n ? {
		width: 18,
		right: a
	} : {};
	if (r === !0) return [{
		...W,
		type: "slider",
		...i
	}, {
		...G,
		type: "inside",
		...i
	}];
	if (Ee(r)) {
		let e = (e) => [e, {
			...G,
			type: "inside",
			...i,
			...r.inside ?? {}
		}];
		if (typeof r.window == "number" && r.window > 0 && r.window < t) {
			let e = r.window / t * 100, i = typeof r.edgeOffset == "number" ? r.edgeOffset : 4, a = r.side === "right" ? {
				start: 100 - e,
				end: 100
			} : {
				start: 0,
				end: e
			};
			return [{
				...W,
				type: "slider",
				...n ? { yAxisIndex: 0 } : { xAxisIndex: 0 },
				...a,
				...n ? o : {
					height: 18,
					bottom: i
				},
				brushSelect: !1,
				...r.slider ?? {}
			}, {
				...G,
				type: "inside",
				...n ? { yAxisIndex: 0 } : { xAxisIndex: 0 },
				...r.inside ?? {}
			}];
		}
		let a = typeof r.threshold == "number" ? r.threshold : 7;
		return r.auto && t > a ? e({
			...W,
			type: "slider",
			...i,
			...o,
			...r.slider ?? {}
		}) : void 0;
	}
	return Array.isArray(r) ? r.map((e) => {
		if (typeof e != "object" || !e) return e;
		let t = e.type;
		return t === "slider" ? {
			...W,
			...e
		} : t === "inside" ? {
			...G,
			...e
		} : e;
	}) : void 0;
}
function Ee(e) {
	return typeof e == "object" && !!e && !Array.isArray(e);
}
V({}, ye);
//#endregion
//#region src/echart/exportSnapshot.ts
var De = 16e3, Oe = 16e3, ke = 268435456;
function Ae(e) {
	if (Array.isArray(e)) return e;
	if (e && typeof e == "object") return [e];
}
function je(e) {
	return e ? e.type === "category" || typeof e.type != "string" && Array.isArray(e.data) : !1;
}
function Me(e, t, n) {
	if (typeof e == "number" && Number.isFinite(e)) return e;
	if (typeof e == "string" && e.endsWith("%")) {
		let n = Number.parseFloat(e);
		if (Number.isFinite(n)) return t * n / 100;
	}
	return n;
}
function Ne(e, t) {
	let { start: n, end: r, startValue: i, endValue: a } = e;
	return typeof n == "number" && typeof r == "number" ? Math.max(1, Math.round(t * (r - n) / 100)) : typeof i == "number" && typeof a == "number" ? Math.max(1, Math.round(a) - Math.round(i) + 1) : null;
}
function Pe(e) {
	let t = e.getOption() ?? {}, n = Ae(t.xAxis), r = Ae(t.yAxis), i = je(n?.[0]), a = je(r?.[0]);
	if (i === a) return null;
	let o = a, s = o ? r[0] : n[0], c = Array.isArray(s?.data) ? s.data.length : 0;
	if (!c) {
		for (let e of Ae(t.series) ?? []) if (Array.isArray(e?.data) && e.data.length > 0) {
			c = e.data.length;
			break;
		}
	}
	if (!c) return null;
	let l = c;
	for (let e of Ae(t.dataZoom) ?? []) {
		let t = o ? "yAxisIndex" : "xAxisIndex";
		if (e[o ? "xAxisIndex" : "yAxisIndex"] !== void 0 || e[t] !== void 0 && Number(e[t]) !== 0) continue;
		let n = Ne(e, c);
		n !== null && n < l && (l = n);
	}
	let u = e.getWidth(), d = e.getHeight(), f = Ae(t.grid)?.[0] ?? {};
	return {
		horizontal: o,
		total: c,
		visible: l,
		grid: {
			top: Me(f.top, d, 60),
			right: Me(f.right, u, u * .1),
			bottom: Me(f.bottom, d, 60),
			left: Me(f.left, u, u * .1)
		},
		viewportWidth: u,
		viewportHeight: d
	};
}
function Fe(e, { maxExportWidth: t, maxExportHeight: n } = {}) {
	let r = t ?? 16e3, i = n ?? 16e3, a = Math.min(8, Math.max(1, e.total / e.visible)), o = e.horizontal ? (e.viewportHeight - e.grid.top - e.grid.bottom) / e.visible : (e.viewportWidth - e.grid.left - e.grid.right) / e.visible, s = e.horizontal ? e.grid.left + e.grid.right + (e.viewportWidth - e.grid.left - e.grid.right) * a : e.grid.left + e.grid.right + o * e.total, c = e.horizontal ? e.grid.top + e.grid.bottom + o * e.total : e.grid.top + e.grid.bottom + (e.viewportHeight - e.grid.top - e.grid.bottom) * a, l = Math.min(1, r / s, i / c);
	return {
		width: Math.max(1, Math.round(s * l)),
		height: Math.max(1, Math.round(c * l)),
		downscaled: l < 1
	};
}
function Ie(e, t) {
	if (!t) return 0;
	let n = e.title;
	return typeof n?.text == "string" && n.text !== "" ? 0 : (e.title = {
		...typeof n == "object" && n ? n : {},
		text: t,
		left: "center",
		top: 4
	}, 34);
}
function Le(e, t) {
	if (t <= 0) return;
	let n = Array.isArray(e.grid) ? e.grid[0] : e.grid;
	n && typeof n.top == "number" && (n.top += t);
	let r = Array.isArray(e.legend) ? e.legend[0] : e.legend;
	r && typeof r.top == "number" && r.top < t + 22 && (r.top = t + 4);
}
function Re(e) {
	let { height: t, grid: n, legend: r, labelExtent: i, titleBand: a, gap: o = 12 } = e, s = i ?? 0, c = n.top;
	a > 0 && (c = Math.max(c, a)), r && r.bottom <= t / 2 && (c = Math.max(c, r.bottom + o));
	let l = Math.max(n.bottom, s + 8);
	r && r.top >= t / 2 && (l = Math.max(l, t - r.top + o + s));
	let u = Math.max(0, c - n.top) + Math.max(0, l - n.bottom);
	return {
		top: Math.max(n.top, c),
		bottom: Math.max(n.bottom, l),
		deficit: u
	};
}
function ze(e) {
	let t = Array.isArray(e.grid) ? e.grid[0] : e.grid;
	return {
		top: typeof t?.top == "number" ? t.top : 0,
		bottom: typeof t?.bottom == "number" ? t.bottom : 0
	};
}
function Be(e) {
	return (Array.isArray(e.series) ? e.series : []).map((e) => e?.name).filter((e) => typeof e == "string" && e !== "");
}
function Ve(e) {
	if (Array.isArray(e)) return e.map(Ve);
	if (e && typeof e == "object") {
		let t = {};
		for (let [n, r] of Object.entries(e)) t[n] = Ve(r);
		return t;
	}
	return e;
}
function He(e) {
	let t = Ve(e);
	return delete t.dataZoom, delete t.brush, t.animation = !1, t;
}
function Ue(e, t, n) {
	if (e * t * n * n <= 268435456) return n;
	let r = Math.sqrt(ke / (e * t));
	return Math.max(1, Math.min(n, r));
}
function We(e, t) {
	let n = document.createElement("a");
	n.href = e, n.download = t, n.click();
}
function Ge(t, n = {}) {
	let r = Pe(t);
	if (!r) return null;
	let i = Fe(r, n), a = He(t.getOption()), o = n.type ?? "png", s = Ie(a, n.title);
	s > 0 && (i.height += s, Le(a, s));
	let c = document.createElement("div");
	c.style.cssText = "position:fixed;left:-99999px;top:0;visibility:hidden;pointer-events:none;", document.body.appendChild(c);
	let l = e.init(c, void 0, {
		width: i.width,
		height: i.height,
		renderer: "canvas"
	}), u;
	try {
		l.setOption(a, { notMerge: !0 });
		let e = oe(l, Be(a)), t = ze(a), r = i.height - t.bottom, c = P(l), d = c === null ? null : c - r, f = Re({
			height: i.height,
			grid: t,
			legend: e,
			labelExtent: d,
			titleBand: s
		});
		f.deficit > 0 && (i.height += f.deficit, l.resize({
			width: i.width,
			height: i.height
		}), l.setOption({ grid: {
			top: f.top,
			bottom: f.bottom
		} })), u = l.getDataURL({
			type: o,
			backgroundColor: n.backgroundColor,
			pixelRatio: Ue(i.width, i.height, n.pixelRatio ?? 2),
			excludeComponents: n.excludeComponents ?? ["toolbox"]
		});
	} finally {
		l.dispose(), c.remove();
	}
	return {
		dataUrl: u,
		width: i.width,
		height: i.height,
		downscaled: i.downscaled
	};
}
//#endregion
//#region src/echart/EChart.tsx
var Ke = i(function({ data: t, config: n, id: r, legendSelected: i, autoClearance: o, clearanceGap: d, autoRotate: f, className: m, style: h }, g) {
	let _ = u(null), v = u(null), y = l(() => K({
		config: n,
		dataset: t
	}), [n, t]), b = a(() => {
		requestAnimationFrame(() => {
			let e = v.current;
			if (e) {
				if (f !== !1) {
					let t = pe(e);
					if (t) {
						let n = e.getOption(), r = (Array.isArray(n?.xAxis) ? n?.xAxis?.[0] : n?.xAxis)?.axisLabel, i = {}, a = r?.rotate ?? 0, o = r?.interval ?? "auto";
						a !== t.rotate && (i.rotate = t.rotate), o !== t.interval && (i.interval = t.interval), Object.keys(i).length > 0 && e.setOption({ xAxis: { axisLabel: i } });
					}
				}
				if (o) {
					let t = F(e, d), n = e.getOption(), r = Array.isArray(n?.grid) ? n?.grid?.[0] : n?.grid;
					if (r) {
						let n = {};
						t.top !== null && r.top !== t.top && (n.top = t.top), t.bottom !== null && r.bottom !== t.bottom && (n.bottom = t.bottom), Object.keys(n).length > 0 && e.setOption({ grid: n });
					}
				}
			}
		});
	}, [
		o,
		f,
		d
	]);
	s(() => {
		let t = _.current;
		if (!t) return;
		let n = e.init(t);
		v.current = n;
		let i = { chartId: r }, a = (e) => A.publish("chart.click", {
			params: e,
			context: i
		}), o = (e) => A.publish("chart.legendChange", {
			params: e,
			context: i
		}), s = (e) => {
			A.publish("chart.dataZoom", {
				params: e,
				context: i
			}), b();
		};
		n.on("click", a), n.on("legendselectchanged", o), n.on("datazoom", s);
		let c = new ResizeObserver(() => {
			n.resize(), b();
		});
		return c.observe(t), () => {
			c.disconnect(), n.off("click", a), n.off("legendselectchanged", o), n.off("datazoom", s), n.dispose(), v.current = null;
		};
	}, [b]);
	let x = u(void 0);
	return s(() => {
		let e = v.current;
		if (!e) return;
		let t = Array.isArray(y.dataZoom) ? y.dataZoom : void 0, n = x.current === void 0 || JSON.stringify(x.current) !== JSON.stringify(t);
		x.current = t;
		let r = e.getOption(), i = Array.isArray(r?.dataZoom) ? r.dataZoom : void 0;
		e.setOption(y, { notMerge: !0 }), !n && i && Array.isArray(y.dataZoom) && e.setOption({ dataZoom: i.map((e) => ({
			start: e.start,
			end: e.end
		})) });
	}, [y]), s(() => {
		b();
	}, [
		b,
		y,
		i
	]), s(() => {
		let e = v.current;
		e && i && e.setOption({ legend: { selected: i } });
	}, [y, i]), c(g, () => ({
		exportImage: (e = {}) => {
			let t = v.current;
			if (!t) return;
			let n = e.type ?? "png";
			if (e.fullData !== !1) {
				let r = Ge(t, e);
				if (r) {
					We(r.dataUrl, `${e.fileName ?? "chart"}.${n}`);
					return;
				}
			}
			We(t.getDataURL({
				type: n,
				backgroundColor: e.backgroundColor,
				pixelRatio: e.pixelRatio ?? 2,
				excludeComponents: e.excludeComponents ?? ["toolbox"]
			}), `${e.fileName ?? "chart"}.${n}`);
		},
		snapshotImage: (e = {}) => {
			let t = v.current;
			if (!t) return null;
			if (e.fullData !== !1) {
				let n = Ge(t, e);
				if (n) return n;
			}
			return {
				dataUrl: t.getDataURL({
					type: e.type ?? "png",
					backgroundColor: e.backgroundColor,
					pixelRatio: e.pixelRatio ?? 2,
					excludeComponents: e.excludeComponents ?? ["toolbox"]
				}),
				width: t.getWidth(),
				height: t.getHeight(),
				downscaled: !1
			};
		},
		getChart: () => v.current
	}), []), /* @__PURE__ */ p("div", {
		ref: _,
		className: m,
		style: {
			width: "100%",
			height: "100%",
			...h
		}
	});
}), qe = (e) => e?.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
//#endregion
//#region ../../node_modules/.pnpm/lucide-react@1.47.0_react@19.3.0/node_modules/lucide-react/dist/esm/shared/src/utils/toLucideIconData.mjs
function Je(e, t, n = []) {
	if (t == null) throw Error("[lucide]: iconNode is required when icon name is used");
	return {
		name: qe(e),
		size: 24,
		node: t,
		...n.length > 0 ? { aliases: n } : {}
	};
}
//#endregion
//#region ../../node_modules/.pnpm/lucide-react@1.47.0_react@19.3.0/node_modules/lucide-react/dist/esm/shared/src/utils/toCamelCase.mjs
var Ye = (e) => {
	let t = "", n = !1;
	for (let r of e) {
		if (r === "-" || r === "_" || r <= " ") {
			n = t.length > 0;
			continue;
		}
		t.length === 0 ? t += r.toLowerCase() : t += n ? r.toUpperCase() : r, n = !1;
	}
	return t;
}, Xe = (e) => {
	let t = Ye(e);
	return t.charAt(0).toUpperCase() + t.slice(1);
}, Ze = (...e) => e.filter((e, t, n) => !!e && e.trim() !== "" && n.indexOf(e) === t).join(" ").trim(), J = {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	"stroke-width": 2,
	"stroke-linecap": "round",
	"stroke-linejoin": "round"
};
//#endregion
//#region ../../node_modules/.pnpm/lucide-react@1.47.0_react@19.3.0/node_modules/lucide-react/dist/esm/shared/src/build/buildLucideIconNode.mjs
function Qe(e) {
	return e != null;
}
function $e(e, t = {}) {
	let n = t.attributeNames ?? {}, r = (e) => n[e] ?? e, i = e.size ?? e.width ?? J.width, a = e.size ?? e.height ?? J.height, o = e.aliases?.filter((e) => typeof e == "string" && e.trim() !== "").map((e) => `lucide-${e}`) ?? [], s = [...e.name ? [`lucide-${e.name}`] : [], ...o], c = t.className?.split(" ").filter(Boolean) ?? [], l = t.includeDefaultClasses === !1 ? Ze(...c) : Ze("lucide", ...s, ...c), u = t.absoluteStrokeWidth ? Number(t.strokeWidth ?? J["stroke-width"]) * Number(e.size ?? e.width ?? J.width) / Number(t.size ?? t.width ?? J.width) : t.strokeWidth ?? J["stroke-width"];
	return [
		"svg",
		{
			...Object.entries(J).reduce((e, [t, n]) => (e[r(t)] = n, e), {}),
			..."color" in t && t.color && { [r("stroke")]: t.color },
			..."size" in t && Qe(t.size) && {
				[r("width")]: t.size,
				[r("height")]: t.size
			},
			..."width" in t && Qe(t.width) && { [r("width")]: t.width },
			..."height" in t && Qe(t.height) && { [r("height")]: t.height },
			[r("stroke-width")]: u,
			...l && { [r("class")]: l },
			[r("viewBox")]: `0 0 ${i} ${a}`,
			...t.hasA11yProp === !1 ? { [r("aria-hidden")]: "true" } : {},
			..."attributes" in t && t.attributes
		},
		e.node.map((e) => {
			let [n, i, a] = e, o = t.nonScalingStroke ? {
				[r("vector-effect")]: "non-scaling-stroke",
				...i
			} : i;
			return a ? [
				n,
				o,
				a
			] : [n, o];
		})
	];
}
//#endregion
//#region ../../node_modules/.pnpm/lucide-react@1.47.0_react@19.3.0/node_modules/lucide-react/dist/esm/shared/src/build/buildLucideIconForReact.mjs
function et(e, t = {}) {
	return $e(e, {
		...t,
		attributeNames: {
			...t.attributeNames,
			class: "className",
			"stroke-width": "strokeWidth",
			"stroke-linecap": "strokeLinecap",
			"stroke-linejoin": "strokeLinejoin",
			"vector-effect": "vectorEffect"
		}
	});
}
//#endregion
//#region ../../node_modules/.pnpm/lucide-react@1.47.0_react@19.3.0/node_modules/lucide-react/dist/esm/shared/src/utils/hasA11yProp.mjs
var tt = (e) => {
	for (let t in e) if (t.startsWith("aria-") || t === "role" || t === "title") return !0;
	return !1;
}, nt = n({}), rt = () => o(nt), it = i(({ color: e, size: t, width: n, height: i, strokeWidth: a, absoluteStrokeWidth: o, nonScalingStroke: s, className: c = "", children: l, iconNode: u = [], icon: d = {
	node: u,
	aliases: [],
	size: 24
}, ...f }, p) => {
	let { size: m = 24, strokeWidth: h = 2, absoluteStrokeWidth: g = !1, nonScalingStroke: _ = !1, color: v = "currentColor", className: y = "" } = rt() ?? {}, b = !!l || tt(f), [x, S, C = []] = et(d, {
		color: e ?? v,
		width: n ?? t ?? m,
		height: i ?? t ?? m,
		strokeWidth: a ?? h,
		absoluteStrokeWidth: o ?? g,
		nonScalingStroke: s ?? _,
		className: Ze(y, c),
		hasA11yProp: b,
		attributes: f
	});
	return r(x, {
		ref: p,
		...S
	}, [...C.map(([e, t]) => r(e, t)), ...Array.isArray(l) ? l : [l]]);
});
//#endregion
//#region ../../node_modules/.pnpm/lucide-react@1.47.0_react@19.3.0/node_modules/lucide-react/dist/esm/createLucideIcon.mjs
function at(e, t = [], n = []) {
	let a = typeof e == "string" ? Je(e, t, n) : e, o = i(({ className: e, ...t }, n) => r(it, {
		ref: n,
		icon: a,
		className: e,
		...t
	}));
	return a.name && (o.displayName = Xe(a.name)), o;
}
//#endregion
//#region ../../node_modules/.pnpm/lucide-react@1.47.0_react@19.3.0/node_modules/lucide-react/dist/esm/icons/chevron-down.mjs
var ot = {
	name: "chevron-down",
	size: 24,
	node: [["path", {
		d: "m6 9 6 6 6-6",
		key: "qrunsl"
	}]]
};
ot.node;
var st = at(ot), ct = {
	name: "chevron-up",
	size: 24,
	node: [["path", {
		d: "m18 15-6-6-6 6",
		key: "153udz"
	}]]
};
ct.node;
var lt = at(ct), ut = {
	name: "loader-circle",
	size: 24,
	node: [["path", {
		d: "M21 12a9 9 0 1 1-6.219-8.56",
		key: "13zald"
	}]],
	aliases: ["loader-2"]
};
ut.node;
var dt = at(ut), ft = [
	"en",
	"ja",
	"fr"
], pt = "en", mt = {
	empty: "No results.",
	loading: "Loading data…",
	loadingMore: "Loading more rows…",
	total: "Total",
	exportCsv: "Export CSV",
	exportXlsx: "Export XLSX",
	filter: "Filter",
	settings: "Settings",
	drillUp: "Drill up (coarser grouping)",
	drillDown: "Drill down (finer grouping)",
	filters: "Filters",
	filtersDescription: "Build search conditions to filter table rows, then apply them to the loaded data.",
	match: "Match",
	noConditions: "No conditions yet. Click \"Add condition\" to create one.",
	filterColumn: "Filter column",
	filterOperator: "Filter operator",
	removeCondition: "Remove condition",
	valuePlaceholder: "Value",
	fromPlaceholder: "From",
	toPlaceholder: "To",
	addCondition: "Add condition",
	clearAll: "Clear all",
	cancel: "Cancel",
	apply: "Apply",
	pinColumns: "Pin columns",
	pinColumnsDescription: "Freeze a column to the left or right edge of the table.",
	pinLeft: "Pin Left",
	pinRight: "Pin Right",
	pinLeftAria: "Pin {column} left",
	pinRightAria: "Pin {column} right",
	opContains: "contains",
	opNotContains: "does not contain",
	opEquals: "=",
	opNotEquals: "≠",
	opStartsWith: "starts with",
	opEndsWith: "ends with",
	opIsEmpty: "is empty",
	opGt: ">",
	opGte: "≥",
	opLt: "<",
	opLte: "≤",
	opBetween: "between",
	opIs: "is (=)",
	opBefore: "before (<)",
	opAfter: "after (>)"
}, ht = {
	en: mt,
	ja: {
		empty: "結果がありません。",
		loading: "データを読み込み中…",
		loadingMore: "さらに行を読み込み中…",
		total: "合計",
		exportCsv: "CSV をエクスポート",
		exportXlsx: "XLSX をエクスポート",
		filter: "絞り込み",
		settings: "設定",
		drillUp: "ドリルアップ（より粗いグループ化）",
		drillDown: "ドリルダウン（より細かいグループ化）",
		filters: "絞り込み条件",
		filtersDescription: "検索条件を設定してテーブルの行を絞り込み、読み込み済みデータに適用します。",
		match: "一致モード",
		noConditions: "条件がありません。「条件を追加」をクリックして作成してください。",
		filterColumn: "対象列",
		filterOperator: "演算子",
		removeCondition: "条件を削除",
		valuePlaceholder: "値",
		fromPlaceholder: "開始値",
		toPlaceholder: "終了値",
		addCondition: "条件を追加",
		clearAll: "すべてクリア",
		cancel: "キャンセル",
		apply: "適用",
		pinColumns: "列の固定",
		pinColumnsDescription: "列をテーブルの左端または右端に固定します。",
		pinLeft: "左に固定",
		pinRight: "右に固定",
		pinLeftAria: "{column} を左に固定",
		pinRightAria: "{column} を右に固定",
		opContains: "含む",
		opNotContains: "含まない",
		opEquals: "=",
		opNotEquals: "≠",
		opStartsWith: "で始まる",
		opEndsWith: "で終わる",
		opIsEmpty: "空である",
		opGt: ">",
		opGte: "≥",
		opLt: "<",
		opLte: "≤",
		opBetween: "範囲内",
		opIs: "一致 (=)",
		opBefore: "より前 (<)",
		opAfter: "より後 (>)"
	},
	fr: {
		empty: "Aucun résultat.",
		loading: "Chargement des données…",
		loadingMore: "Chargement de lignes supplémentaires…",
		total: "Total",
		exportCsv: "Exporter CSV",
		exportXlsx: "Exporter XLSX",
		filter: "Filtrer",
		settings: "Paramètres",
		drillUp: "Remonter (regroupement plus grossier)",
		drillDown: "Descendre (regroupement plus fin)",
		filters: "Filtres",
		filtersDescription: "Créez des conditions pour filtrer les lignes du tableau, puis appliquez-les aux données chargées.",
		match: "Correspondance",
		noConditions: "Aucune condition pour l'instant. Cliquez sur « Ajouter une condition » pour en créer une.",
		filterColumn: "Colonne",
		filterOperator: "Opérateur",
		removeCondition: "Supprimer la condition",
		valuePlaceholder: "Valeur",
		fromPlaceholder: "De",
		toPlaceholder: "À",
		addCondition: "Ajouter une condition",
		clearAll: "Tout effacer",
		cancel: "Annuler",
		apply: "Appliquer",
		pinColumns: "Épingler les colonnes",
		pinColumnsDescription: "Figez une colonne au bord gauche ou droit du tableau.",
		pinLeft: "Épingler à gauche",
		pinRight: "Épingler à droite",
		pinLeftAria: "Épingler {column} à gauche",
		pinRightAria: "Épingler {column} à droite",
		opContains: "contient",
		opNotContains: "ne contient pas",
		opEquals: "=",
		opNotEquals: "≠",
		opStartsWith: "commence par",
		opEndsWith: "finit par",
		opIsEmpty: "est vide",
		opGt: ">",
		opGte: "≥",
		opLt: "<",
		opLte: "≤",
		opBetween: "entre",
		opIs: "est (=)",
		opBefore: "avant (<)",
		opAfter: "après (>)"
	}
};
function gt(e) {
	if (!e) return "en";
	let t = String(e).toLowerCase().replace("_", "-").split("-")[0];
	return ft.includes(t) ? t : "en";
}
var _t = null;
function vt(e) {
	_t = e;
}
function yt(e) {
	return e.replace(/\{\{|\}\}/g, (e) => e === "{{" ? "{" : "}");
}
function Y(e, t, n) {
	let r = gt(t), i = _t?.(e, r)?.trim() || ht[r][e] || mt[e];
	if (i = yt(i), n) for (let [e, t] of Object.entries(n)) t !== void 0 && (i = i.replaceAll(`{${e}}`, String(t)));
	return i;
}
//#endregion
//#region src/echart/DrillControls.tsx
var bt = "inline-flex h-8 cursor-pointer items-center gap-1.5 rounded-md border border-input bg-background px-2.5 text-xs font-medium text-foreground hover:bg-accent hover:text-accent-foreground";
function xt({ display: e = !1, onDrillUp: t, onDrillDown: n, canDrillUp: r = !0, canDrillDown: i = !0, disabled: a = !1, locale: o }) {
	return e ? /* @__PURE__ */ m("div", {
		className: `flex items-center gap-1${a ? " opacity-50" : ""}`,
		"data-testid": "drill-controls",
		children: [r && /* @__PURE__ */ p("button", {
			type: "button",
			className: bt,
			disabled: a,
			"aria-label": Y("drillUp", o),
			title: Y("drillUp", o),
			"data-testid": "drill-up-button",
			onClick: () => t?.(),
			children: /* @__PURE__ */ p(lt, {
				className: "size-4",
				"aria-hidden": !0
			})
		}), i && /* @__PURE__ */ p("button", {
			type: "button",
			className: bt,
			disabled: a,
			"aria-label": Y("drillDown", o),
			title: Y("drillDown", o),
			"data-testid": "drill-down-button",
			onClick: () => n?.(),
			children: /* @__PURE__ */ p(st, {
				className: "size-4",
				"aria-hidden": !0
			})
		})]
	}) : null;
}
//#endregion
//#region src/echart/drill.ts
function St(e, t, n) {
	if (e.length === 0) return t;
	let r = e.indexOf(t), i = n === "up" ? 0 : e.length - 1, a = r === -1 ? i : r, o = n === "up" ? a - 1 : a + 1;
	return e[Math.min(e.length - 1, Math.max(0, o))];
}
//#endregion
//#region src/echart/loadMore.ts
var Ct = 30, wt = 2, Tt = 250, Et = 500, Dt = .5;
function Ot(e = 30, t = 2) {
	return e * t;
}
function kt(e, t, n = 30) {
	return Math.min(n, Math.max(0, t - e));
}
function At(e, t) {
	return e.slice(Math.max(0, e.length - t));
}
function jt(e, t = 30) {
	return {
		startValue: Math.max(0, e - t),
		endValue: Math.max(0, e - 1)
	};
}
function Mt(e, t, n) {
	return {
		startValue: e + n,
		endValue: t + n
	};
}
function Nt(e, { disabled: t = !1 } = {}) {
	return [{
		type: "slider",
		xAxisIndex: 0,
		startValue: e.startValue,
		endValue: e.endValue,
		height: 18,
		bottom: 4,
		brushSelect: !1,
		disabled: t
	}, {
		type: "inside",
		xAxisIndex: 0,
		startValue: e.startValue,
		endValue: e.endValue,
		moveOnMouseMove: !0,
		zoomOnMouseWheel: !1,
		moveOnMouseWheel: !0,
		disabled: t
	}];
}
function Pt({ getChart: e, totalCount: t, windowSize: n = 30, preloadBatches: r = 2, leftEdgePct: i = Dt, throttleMs: o = 250, applyDelayMs: c = 500, resetKey: l = "" }) {
	let [f, p] = d(() => Ot(n, r)), [m, h] = d(null), [g, _] = d(!1), v = u(f), y = u(t), b = u(n), x = u(r), S = u(i), C = u(o), w = u(c);
	s(() => {
		v.current = f, y.current = t, b.current = n, x.current = r, S.current = i, C.current = o, w.current = c;
	}, [
		f,
		t,
		n,
		r,
		i,
		o,
		c
	]);
	let T = u(null), E = u(!1), D = u(0);
	s(() => () => {
		T.current && clearTimeout(T.current);
	}, []);
	let O = a(() => {
		T.current &&= (clearTimeout(T.current), null), E.current = !1, _(!1), p(Ot(b.current, x.current)), h(null);
	}, []), k = u(l);
	s(() => {
		k.current !== l && (k.current = l, O());
	}, [l, O]);
	let ee = a(() => {
		let t = e();
		if (!t) return;
		let n = t.getOption()?.dataZoom?.[0];
		if (!n) return;
		let r = v.current;
		if (r >= y.current || E.current || Date.now() - D.current < C.current || (n.start ?? 0) > S.current) return;
		D.current = Date.now();
		let i = kt(r, y.current, b.current);
		if (i <= 0) return;
		let a = r + i, o = typeof n.startValue == "number" ? n.startValue : Math.round((n.start ?? 0) / 100 * (r - 1)), s = typeof n.endValue == "number" ? n.endValue : Math.round((n.end ?? 100) / 100 * (r - 1));
		E.current = !0, _(!0), T.current = setTimeout(() => {
			T.current = null, E.current = !1, p(a), h(Mt(o, s, i)), _(!1);
		}, w.current);
	}, [e]);
	return {
		loadedCount: f,
		loadingMore: g,
		zoom: m ?? jt(Math.min(f, t), n),
		handleDataZoom: ee,
		reset: O
	};
}
//#endregion
//#region src/echart/series.ts
function Ft(e, t, n, r) {
	if (t != null && (Array.isArray(t) ? t : [t]).includes(e)) return {
		color: n,
		...It(r) ?? {}
	};
}
function It(e) {
	if (e) return Object.fromEntries(Object.entries(e).filter(([, e]) => e !== void 0));
}
function Lt(e) {
	return {
		name: e.name,
		type: "bar",
		field: e.field,
		color: e.color,
		barWidth: e.barWidth,
		yAxisIndex: e.yAxisIndex,
		emphasis: e.disableHover === !1 ? void 0 : { disabled: !0 },
		itemStyleByIndex: (t) => Ft(t, e.selectedIndex, e.highlightColor ?? e.color, e.highlightGlow)
	};
}
function Rt(e) {
	let t = e.stack ?? "total", n = { disabled: !0 };
	return [{
		name: e.name,
		type: "bar",
		field: e.shareField,
		color: e.shareColor,
		yAxisIndex: e.yAxisIndex,
		barWidth: e.barWidth,
		stack: t,
		emphasis: n,
		itemStyleByIndex: (t) => Ft(t, e.selectedIndex, e.shareHighlightColor ?? e.shareColor, e.highlightGlow)
	}, {
		name: e.name,
		type: "bar",
		field: e.remainderField,
		color: e.remainderColor,
		yAxisIndex: e.yAxisIndex,
		barWidth: e.barWidth,
		stack: t,
		emphasis: n,
		itemStyleByIndex: (t) => Ft(t, e.selectedIndex, e.remainderHighlightColor ?? e.remainderColor, e.highlightGlow)
	}];
}
function zt(e) {
	return {
		name: e.name,
		type: "line",
		field: e.field,
		color: e.color,
		yAxisIndex: e.yAxisIndex,
		symbol: e.symbol ?? "circle",
		symbolSize: e.symbolSize ?? 8,
		emphasis: e.hover === void 0 ? {
			disabled: !0,
			itemStyle: { color: e.color }
		} : e.hover === !1 ? void 0 : { itemStyle: { color: e.hover.color ?? e.color } }
	};
}
function Bt(e) {
	return {
		name: e.name,
		type: "line",
		field: e.field,
		yAxisIndex: e.yAxisIndex,
		symbol: "none",
		color: e.color ?? "transparent",
		emphasis: { disabled: !0 }
	};
}
//#endregion
//#region src/echart/scale.ts
function Vt(e) {
	if (!Number.isFinite(e) || e <= 0) return 1;
	let t = 10 ** Math.floor(Math.log10(e));
	for (let n of [
		1,
		2,
		2.5,
		5,
		10
	]) if (e <= n * t) return n * t;
	return 10 * t;
}
function Ht(e, t) {
	if (!Number.isFinite(t) || t <= 0) throw Error("[echart] stepMax: step must be a positive number");
	return !Number.isFinite(e) || e <= 0 ? t : Math.ceil(e / t) * t;
}
function Ut(e, t, n) {
	if (t <= 0) return {
		start: 0,
		end: 100
	};
	let r = Math.min(n, t);
	if (r >= t) return {
		start: 0,
		end: 100
	};
	let i = r / t * 100, a = (e + .5) / t * 100, o = Math.max(0, Math.min(a - i / 2, 100 - i));
	return {
		start: o,
		end: o + i
	};
}
//#endregion
//#region ../../node_modules/.pnpm/@tanstack+virtual-core@3.17.11/node_modules/@tanstack/virtual-core/dist/esm/lazy-measurements.js
function Wt(e) {
	return typeof e == "object" ? e.key : e;
}
function Gt(e, t) {
	let n = e.length;
	return new Proxy(e, { get(e, r, i) {
		if (typeof r == "string") {
			let i = r.charCodeAt(0);
			if (i >= 48 && i <= 57) {
				let i = +r;
				if (Number.isInteger(i) && i >= 0 && i < n) {
					let n = e[i];
					if (typeof n != "object") {
						let r = t[i * 2];
						n = e[i] = {
							index: i,
							key: n,
							start: r,
							size: t[i * 2 + 1],
							end: r + t[i * 2 + 1],
							lane: 0
						};
					}
					return n;
				}
			}
			if (r === "length") return n;
		}
		return Reflect.get(e, r, i);
	} });
}
//#endregion
//#region ../../node_modules/.pnpm/@tanstack+virtual-core@3.17.11/node_modules/@tanstack/virtual-core/dist/esm/utils.js
function X(e, t, n) {
	let r = n.initialDeps ?? [], i, a = !0;
	function o() {
		let o = process.env.NODE_ENV !== "production" && !!n.key && !!n.debug?.call(n), s = 0;
		o && (s = Date.now());
		let c = e();
		if (!(c.length !== r.length || c.some((e, t) => r[t] !== e))) return i;
		r = c;
		let l = 0;
		if (o && (l = Date.now()), i = t(...c), o) {
			let e = Math.round((Date.now() - s) * 100) / 100, t = Math.round((Date.now() - l) * 100) / 100, r = t / 16, i = (e, t) => {
				for (e = String(e); e.length < t;) e = " " + e;
				return e;
			};
			console.info(`%c⏱ ${i(t, 5)} /${i(e, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * r, 120))}deg 100% 31%);`, n?.key);
		}
		return n?.onChange && !(a && n.skipInitialOnChange) && n.onChange(i), a = !1, i;
	}
	return o.updateDeps = (e) => {
		r = e;
	}, o;
}
function Kt(e, t) {
	if (e === void 0) throw Error(`Unexpected undefined${t ? `: ${t}` : ""}`);
	return e;
}
var qt = (e, t) => Math.abs(e - t) < 1.01, Jt = (e, t, n) => {
	let r;
	return Object.assign(function(...i) {
		e.clearTimeout(r), r = e.setTimeout(() => t.apply(this, i), n);
	}, { cancel: () => {
		e.clearTimeout(r);
	} });
}, Yt, Xt = () => {
	if (Yt !== void 0) return Yt;
	if (typeof navigator > "u") return Yt = !1;
	if (/iP(hone|od|ad)/.test(navigator.userAgent)) return Yt = !0;
	let e = navigator.maxTouchPoints;
	return Yt = navigator.platform === "MacIntel" && e !== void 0 && e > 0;
}, Zt = (e) => {
	let { offsetWidth: t, offsetHeight: n } = e;
	return {
		width: t,
		height: n
	};
}, Qt = (e) => e, $t = (e) => {
	let t = Math.max(e.startIndex - e.overscan, 0), n = Math.min(e.endIndex + e.overscan, e.count - 1) - t + 1, r = Array(n);
	for (let e = 0; e < n; e++) r[e] = t + e;
	return r;
}, en = (e, t) => {
	let n = e.scrollElement;
	if (!n) return;
	let r = e.targetWindow;
	if (!r) return;
	let i = (e) => {
		let { width: n, height: r } = e;
		t({
			width: Math.round(n),
			height: Math.round(r)
		});
	};
	if (i(Zt(n)), !r.ResizeObserver) return () => {};
	let a = new r.ResizeObserver((t) => {
		let r = () => {
			let e = t[0];
			if (e?.borderBoxSize) {
				let t = e.borderBoxSize[0];
				if (t) {
					i({
						width: t.inlineSize,
						height: t.blockSize
					});
					return;
				}
			}
			i(Zt(n));
		};
		e.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(r) : r();
	});
	return a.observe(n, { box: "border-box" }), () => {
		a.unobserve(n);
	};
}, tn = { passive: !0 }, nn = typeof window > "u" || "onscrollend" in window, rn = (e, t, n) => {
	let r = e.scrollElement;
	if (!r) return;
	let i = e.targetWindow;
	if (!i) return;
	let a = e.options.useScrollendEvent && nn, o = 0, s = a ? null : Jt(i, () => t(n(r), !1), e.options.isScrollingResetDelay), c = (e) => () => {
		o = n(r), s?.(), t(o, e);
	}, l = c(!0), u = c(!1);
	return r.addEventListener("scroll", l, tn), a && r.addEventListener("scrollend", u, tn), () => {
		r.removeEventListener("scroll", l), a && r.removeEventListener("scrollend", u), s?.cancel();
	};
}, an = (e, t) => rn(e, t, (t) => {
	let { horizontal: n, isRtl: r } = e.options;
	return n ? t.scrollLeft * (r && -1 || 1) : t.scrollTop;
}), on = (e, t, n) => {
	if (n.options.useCachedMeasurements) {
		let t = n.indexFromElement(e), r = n.options.getItemKey(t);
		return n.itemSizeCache.get(r) ?? n.options.estimateSize(t);
	}
	if (t?.borderBoxSize) {
		let e = t.borderBoxSize[0];
		if (e) return Math.round(e[n.options.horizontal ? "inlineSize" : "blockSize"]);
	}
	if (!t) {
		let t = n.indexFromElement(e), r = n.options.getItemKey(t), i = n.itemSizeCache.get(r);
		if (i !== void 0) return i;
	}
	return e[n.options.horizontal ? "offsetWidth" : "offsetHeight"];
}, sn = (e, { adjustments: t = 0, behavior: n }, r) => {
	var i, a;
	(a = (i = r.scrollElement)?.scrollTo) == null || a.call(i, {
		[r.options.horizontal ? "left" : "top"]: e + t,
		behavior: n
	});
};
function cn(e, t, n, r) {
	if (t === 0) return !1;
	let i = r(0), a = /* @__PURE__ */ new Set(), o = 0;
	for (; o < e;) {
		let e = n(o);
		if (e === i) break;
		a.add(e), o++;
	}
	let s = e - o;
	if (s === 0 || s >= t) return !1;
	for (let e = 0; e < s; e++) if (r(e) !== n(o + e)) return !1;
	for (let e = s; e < t; e++) if (a.has(r(e))) return !1;
	return !0;
}
var ln = class {
	constructor(e) {
		this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.isScrolling = !1, this.scrollState = null, this.measurementsCache = [], this._singleLaneMeasurements = null, this.itemSizeCache = /* @__PURE__ */ new Map(), this.itemSizeCacheVersion = 0, this.laneAssignments = /* @__PURE__ */ new Map(), this.pendingMin = null, this.prevLanes = void 0, this.lanesChangedFlag = !1, this.lanesSettling = !1, this.pendingScrollAnchor = null, this.scrollRect = null, this.scrollOffset = null, this.scrollDirection = null, this.scrollAdjustments = 0, this._iosDeferredAdjustment = 0, this._iosTouching = !1, this._iosJustTouchEnded = !1, this._iosTouchEndTimerId = null, this._intendedScrollOffset = null, this._clampedAdjustment = null, this.elementsCache = /* @__PURE__ */ new Map(), this.now = () => {
			var e;
			return ((e = this.targetWindow?.performance)?.now)?.call(e) ?? Date.now();
		}, this.observer = /* @__PURE__ */ (() => {
			let e = null, t = () => e || (!this.targetWindow || !this.targetWindow.ResizeObserver ? null : e = new this.targetWindow.ResizeObserver((e) => {
				e.forEach((e) => {
					let t = () => {
						let t = e.target, n = this.indexFromElement(t);
						if (!t.isConnected) {
							this.observer.unobserve(t);
							for (let [e, n] of this.elementsCache) if (n === t) {
								this.elementsCache.delete(e);
								break;
							}
							return;
						}
						this.isIndexInRange(n) && this.shouldMeasureDuringScroll(n) && this.resizeItem(n, this.options.measureElement(t, e, this));
					};
					this.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(t) : t();
				});
			}));
			return {
				disconnect: () => {
					var n;
					(n = t()) == null || n.disconnect(), e = null;
				},
				observe: (e) => t()?.observe(e, { box: "border-box" }),
				unobserve: (e) => t()?.unobserve(e)
			};
		})(), this.range = null, this.setOptions = (e) => {
			let t = {
				debug: !1,
				initialOffset: 0,
				overscan: 1,
				paddingStart: 0,
				paddingEnd: 0,
				scrollPaddingStart: 0,
				scrollPaddingEnd: 0,
				horizontal: !1,
				getItemKey: Qt,
				rangeExtractor: $t,
				onChange: () => {},
				measureElement: on,
				initialRect: {
					width: 0,
					height: 0
				},
				scrollMargin: 0,
				gap: 0,
				indexAttribute: "data-index",
				initialMeasurementsCache: [],
				lanes: 1,
				anchorTo: "start",
				followOnAppend: !1,
				scrollEndThreshold: 1,
				isScrollingResetDelay: 150,
				enabled: !0,
				isRtl: !1,
				useScrollendEvent: !1,
				useAnimationFrameWithResizeObserver: !1,
				laneAssignmentMode: "estimate",
				useCachedMeasurements: !1
			};
			for (let n in e) {
				let r = e[n];
				r !== void 0 && (t[n] = r);
			}
			let n = this.options, r = null, i = null, a = !1;
			if (n !== void 0 && n.enabled && t.enabled && t.anchorTo === "end" && this.scrollElement !== null) {
				let e = n.count, o = t.count, s = this.getMeasurements(), c = this._singleLaneMeasurements?.items ?? s, l = (e) => Wt(c[e]), u = e > 0 ? l(0) : null, d = e > 0 ? l(e - 1) : null;
				if (o !== e || e > 0 && o > 0 && (t.getItemKey(0) !== u || t.getItemKey(o - 1) !== d)) {
					a = !0;
					let c = e > 0 ? this.getVirtualItemForOffset(this.getScrollOffset()) ?? s[0] : null;
					c && (r = [c.key, this.getScrollOffset() - c.start]);
					let u = t.followOnAppend === !0 ? "auto" : t.followOnAppend || null;
					u && o > 0 && this.isAtEnd(n.scrollEndThreshold) && (e === 0 || t.getItemKey(o - 1) !== d) && (o > e || cn(e, o, l, t.getItemKey)) && (i = u);
				}
			}
			this.options = t, a && (this.pendingMin = 0, this.itemSizeCacheVersion++);
			let o = !1, s = 0;
			if (r && this.scrollOffset !== null) {
				let [e, t] = r, n = this.getMeasurements(), { count: a, getItemKey: c } = this.options, l = 0;
				for (; l < a && c(l) !== e;) l++;
				if (l < a) {
					let e = n[l];
					if (e) {
						let n = Math.max(0, e.start + t);
						!i && n !== this.scrollOffset && (s = n - this.scrollOffset, this.scrollOffset = n, o = !0);
					}
				}
			}
			(o || i) && (this.pendingScrollAnchor = [
				o ? r[0] : null,
				o ? r[1] : 0,
				i,
				s
			]);
		}, this.notify = (e) => {
			var t, n;
			(n = (t = this.options).onChange) == null || n.call(t, this, e);
		}, this.maybeNotify = X(() => (this.calculateRange(), [
			this.isScrolling,
			this.range ? this.range.startIndex : null,
			this.range ? this.range.endIndex : null
		]), (e) => {
			this.notify(e);
		}, {
			key: process.env.NODE_ENV !== "production" && "maybeNotify",
			debug: () => this.options.debug,
			initialDeps: [
				this.isScrolling,
				this.range ? this.range.startIndex : null,
				this.range ? this.range.endIndex : null
			]
		}), this.cleanup = () => {
			this.unsubs.filter(Boolean).forEach((e) => e()), this.unsubs = [], this.observer.disconnect(), this.rafId != null && this.targetWindow && (this.targetWindow.cancelAnimationFrame(this.rafId), this.rafId = null), this.scrollState = null, this.isScrolling = !1, this.scrollDirection = null, this._iosDeferredAdjustment = 0, this._iosTouching = !1, this._iosJustTouchEnded = !1, this._clampedAdjustment = null, this.scrollElement = null, this.targetWindow = null;
		}, this._didMount = () => () => {
			this.cleanup();
		}, this._willUpdate = () => {
			let e = this.options.enabled ? this.options.getScrollElement() : null;
			if (this.scrollElement !== e) {
				if (this.cleanup(), !e) {
					this.maybeNotify();
					return;
				}
				if (this.scrollElement = e, this.targetWindow = this.scrollElement && "ownerDocument" in this.scrollElement ? this.scrollElement.ownerDocument.defaultView : this.scrollElement?.window ?? null, this.elementsCache.forEach((e) => {
					this.observer.observe(e);
				}), this.unsubs.push(this.options.observeElementRect(this, (e) => {
					this.scrollRect = e, this.maybeNotify();
				})), this.unsubs.push(this.options.observeElementOffset(this, (e, t) => {
					if (t && this._intendedScrollOffset === null && e === this.scrollOffset) return;
					this._intendedScrollOffset !== null && Math.abs(e - this._intendedScrollOffset) < 1.5 && (e = this._intendedScrollOffset), this._intendedScrollOffset = null, this._clampedAdjustment !== null && Math.abs(e - this._clampedAdjustment.maxAtWrite) >= 1.5 && (this._clampedAdjustment = null), this.scrollAdjustments = 0;
					let n = this.getScrollOffset();
					this.scrollDirection = t ? n === e ? this.scrollDirection : n < e ? "forward" : "backward" : null, this.scrollOffset = e, this.isScrolling = t, this._flushIosDeferredIfReady(), this.scrollState && this.scheduleScrollReconcile(), this.maybeNotify();
				})), "addEventListener" in this.scrollElement) {
					let e = this.scrollElement, t = () => {
						this._iosTouching = !0, this._iosJustTouchEnded = !1, this._iosTouchEndTimerId !== null && this.targetWindow != null && (this.targetWindow.clearTimeout(this._iosTouchEndTimerId), this._iosTouchEndTimerId = null);
					}, n = () => {
						this._iosTouching = !1, Xt() && this.targetWindow != null && (this._iosJustTouchEnded = !0, this._iosTouchEndTimerId = this.targetWindow.setTimeout(() => {
							this._iosJustTouchEnded = !1, this._iosTouchEndTimerId = null, this._flushIosDeferredIfReady();
						}, 150));
					};
					e.addEventListener("touchstart", t, tn), e.addEventListener("touchend", n, tn), this.unsubs.push(() => {
						e.removeEventListener("touchstart", t), e.removeEventListener("touchend", n), this._iosTouchEndTimerId !== null && this.targetWindow != null && (this.targetWindow.clearTimeout(this._iosTouchEndTimerId), this._iosTouchEndTimerId = null);
					});
				}
				this._scrollToOffset(this.getScrollOffset(), {
					adjustments: void 0,
					behavior: void 0
				});
			}
			let t = this.pendingScrollAnchor;
			if (this.pendingScrollAnchor = null, t && this.scrollElement && this.options.enabled) {
				let [e, n, r, i] = t;
				e !== null && !r && (Xt() && (this.isScrolling || this._iosTouching || this._iosJustTouchEnded) ? i !== 0 && (this._iosDeferredAdjustment += i) : this.scrollState?.behavior === "smooth" && !qt(this.getScrollOffset() - i, this.scrollState.lastTargetOffset) || this._scrollToOffset(this.getScrollOffset(), {
					adjustments: void 0,
					behavior: void 0
				})), r && this.scrollToEnd({ behavior: r });
			}
			this._retryClampedAdjustment();
		}, this._retryClampedAdjustment = () => {
			if (this._clampedAdjustment === null || !this.scrollElement || !this.options.enabled) return;
			let { target: e, maxAtWrite: t } = this._clampedAdjustment, n = this.getMaxScrollOffset();
			n > t + .5 && (this._clampedAdjustment = e > n + .5 ? {
				target: e,
				maxAtWrite: n
			} : null, this._scrollToOffset(e, {
				adjustments: void 0,
				behavior: void 0
			}));
		}, this._flushIosDeferredIfReady = () => {
			if (this._iosDeferredAdjustment === 0 || this.isScrolling || this._iosTouching || this._iosJustTouchEnded) return;
			let e = this.getScrollOffset(), t = this.getMaxScrollOffset();
			if (e < 0 || e > t) return;
			if (this._iosDeferredAdjustment < 0 && e >= t - 1) {
				this._iosDeferredAdjustment = 0;
				return;
			}
			let n = this._iosDeferredAdjustment;
			this._iosDeferredAdjustment = 0, this._scrollToOffset(e, {
				adjustments: this.scrollAdjustments += n,
				behavior: void 0
			});
		}, this.rafId = null, this.getSize = () => this.options.enabled ? (this.scrollRect = this.scrollRect ?? this.options.initialRect, this.scrollRect[this.options.horizontal ? "width" : "height"]) : (this.scrollRect = null, 0), this.getScrollOffset = () => this.options.enabled ? (this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset == "function" ? this.options.initialOffset() : this.options.initialOffset), this.scrollOffset) : (this.scrollOffset = null, 0), this.getMeasurementOptions = X(() => [
			this.options.count,
			this.options.paddingStart,
			this.options.scrollMargin,
			this.options.getItemKey,
			this.options.enabled,
			this.options.lanes,
			this.options.laneAssignmentMode,
			this.options.gap
		], (e, t, n, r, i, a, o, s) => (this.prevLanes !== void 0 && this.prevLanes !== a && (this.lanesChangedFlag = !0), this.prevLanes = a, this.pendingMin = null, {
			count: e,
			paddingStart: t,
			scrollMargin: n,
			getItemKey: r,
			enabled: i,
			lanes: a,
			laneAssignmentMode: o,
			gap: s
		}), { key: !1 }), this.isIndexInRange = (e) => e >= 0 && e < this.options.count, this.getMeasurements = X(() => [this.getMeasurementOptions(), this.itemSizeCacheVersion], ({ count: e, paddingStart: t, scrollMargin: n, getItemKey: r, enabled: i, lanes: a, laneAssignmentMode: o, gap: s }, c) => {
			let l = this.itemSizeCache;
			if (!i) return this.measurementsCache = [], this._singleLaneMeasurements = null, this.itemSizeCache.clear(), this.laneAssignments.clear(), [];
			if (this.laneAssignments.size > e) for (let t of this.laneAssignments.keys()) t >= e && this.laneAssignments.delete(t);
			this.lanesChangedFlag && (this.lanesChangedFlag = !1, this.lanesSettling = !0, this.measurementsCache = [], this._singleLaneMeasurements = null, this.itemSizeCache.clear(), this.laneAssignments.clear(), this.pendingMin = null), this.measurementsCache.length === 0 && !this.lanesSettling && (this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach((e) => {
				this.itemSizeCache.set(e.key, e.size);
			}));
			let u = this.lanesSettling ? 0 : this.pendingMin ?? 0;
			if (this.pendingMin = null, this.lanesSettling && this.measurementsCache.length === e && (this.lanesSettling = !1), a === 1) {
				let i = e * 2, a = this._singleLaneMeasurements?.flat;
				if (!a || a.length < i) {
					let e = new Float64Array(i);
					a && u > 0 && e.set(a.subarray(0, u * 2)), a = e;
				}
				let o = u === 0 ? Array(e) : this._singleLaneMeasurements.items.slice(), c;
				if (u === 0) c = t + n;
				else {
					let e = u - 1;
					c = a[e * 2] + a[e * 2 + 1] + s;
				}
				for (let t = u; t < e; t++) {
					let e = r(t);
					o[t] = e;
					let n = l.get(e), i = typeof n == "number" ? n : this.options.estimateSize(t);
					a[t * 2] = c, a[t * 2 + 1] = i, c += i + s;
				}
				this._singleLaneMeasurements = {
					flat: a,
					items: o
				};
				let d = Gt(o, a);
				return this.measurementsCache = d, d;
			}
			let d = this.measurementsCache.slice(0, u), f = Array(a).fill(void 0), p = new Float64Array(a), m = 0;
			for (let e = 0; e < u; e++) {
				let t = d[e];
				t && (f[t.lane] === void 0 && m++, f[t.lane] = e, p[t.lane] = t.end);
			}
			for (let i = u; i < e; i++) {
				let e = r(i), c = this.laneAssignments.get(i), u, h, g = o === "estimate" || l.has(e);
				if (c !== void 0 && this.options.lanes > 1) {
					u = c;
					let e = f[u], r = e === void 0 ? void 0 : d[e];
					h = r ? r.end + s : t + n;
				} else if (m === a) {
					let e = 0, t = p[0], n = f[0];
					for (let r = 1; r < a; r++) {
						let i = p[r];
						(i < t || i === t && f[r] < n) && (e = r, t = i, n = f[r]);
					}
					u = e, h = t + s, g && this.laneAssignments.set(i, u);
				} else u = i % this.options.lanes, h = t + n, g && this.laneAssignments.set(i, u);
				let _ = l.get(e), v = typeof _ == "number" ? _ : this.options.estimateSize(i), y = h + v;
				d[i] = {
					index: i,
					start: h,
					size: v,
					end: y,
					key: e,
					lane: u
				}, f[u] === void 0 && m++, f[u] = i, p[u] = y;
			}
			return this.measurementsCache = d, d;
		}, {
			key: process.env.NODE_ENV !== "production" && "getMeasurements",
			debug: () => this.options.debug
		}), this.calculateRange = X(() => [
			this.getMeasurements(),
			this.getSize(),
			this.getScrollOffset(),
			this.options.lanes
		], (e, t, n, r) => e.length === 0 || t === 0 ? (this.range = null, null) : (this.range = fn(e, t, n, r, r === 1 && this._singleLaneMeasurements !== null ? this._singleLaneMeasurements.flat : null), this.range), {
			key: process.env.NODE_ENV !== "production" && "calculateRange",
			debug: () => this.options.debug
		}), this.getVirtualIndexes = X(() => {
			let e = null, t = null, n = this.calculateRange();
			return n && (e = n.startIndex, t = n.endIndex), this.maybeNotify.updateDeps([
				this.isScrolling,
				e,
				t
			]), [
				this.options.rangeExtractor,
				this.options.overscan,
				this.options.count,
				e,
				t
			];
		}, (e, t, n, r, i) => r === null || i === null ? [] : e({
			startIndex: r,
			endIndex: i,
			overscan: t,
			count: n
		}), {
			key: process.env.NODE_ENV !== "production" && "getVirtualIndexes",
			debug: () => this.options.debug
		}), this.indexFromElement = (e) => {
			let t = this.options.indexAttribute, n = e.getAttribute(t);
			return n ? parseInt(n, 10) : (console.warn(`Missing attribute name '${t}={index}' on measured element.`), -1);
		}, this.shouldMeasureDuringScroll = (e) => {
			if (!this.scrollState || this.scrollState.behavior !== "smooth") return !0;
			let t = this.scrollState.index ?? this.getVirtualItemForOffset(this.scrollState.lastTargetOffset)?.index;
			if (t !== void 0 && this.range) {
				let n = Math.max(this.options.overscan, Math.ceil((this.range.endIndex - this.range.startIndex) / 2)), r = Math.max(0, t - n), i = Math.min(this.options.count - 1, t + n);
				return e >= r && e <= i;
			}
			return !0;
		}, this.measureElement = (e) => {
			if (!e) {
				this.elementsCache.forEach((e, t) => {
					e.isConnected || (this.observer.unobserve(e), this.elementsCache.delete(t));
				});
				return;
			}
			let t = this.indexFromElement(e);
			if (!this.isIndexInRange(t)) return;
			let n = this.options.getItemKey(t), r = this.elementsCache.get(n);
			r !== e && (r && this.observer.unobserve(r), this.observer.observe(e), this.elementsCache.set(n, e)), (!this.isScrolling || this.scrollState) && this.shouldMeasureDuringScroll(t) && this.resizeItem(t, this.options.measureElement(e, void 0, this));
		}, this.resizeItem = (e, t) => {
			if (!this.isIndexInRange(e)) return;
			let n, r, i, a = this._singleLaneMeasurements?.flat;
			if (this.options.lanes === 1 && a != null) i = this.options.getItemKey(e), r = a[e * 2], n = a[e * 2 + 1];
			else {
				let t = this.measurementsCache[e];
				if (!t) return;
				i = t.key, r = t.start, n = t.size;
			}
			let o = this.itemSizeCache.get(i) ?? n, s = t - o;
			if (s !== 0) {
				let a = this.options.anchorTo === "end" && this.scrollState?.behavior !== "smooth" && this.getVirtualDistanceFromEnd() <= this.options.scrollEndThreshold, c = a ? this.getTotalSize() : 0, l = this.getScrollOffset() + this.scrollAdjustments, u = this.itemSizeCache.has(i) ? r + o <= l && this.scrollDirection !== "backward" : r < l, d = this.scrollState?.behavior !== "smooth" && (this.shouldAdjustScrollPositionOnItemSizeChange === void 0 ? u : this.shouldAdjustScrollPositionOnItemSizeChange(this.measurementsCache[e] ?? {
					index: e,
					key: i,
					start: r,
					size: n,
					end: r + n,
					lane: 0
				}, s, this));
				(this.pendingMin === null || e < this.pendingMin) && (this.pendingMin = e), this.itemSizeCache.set(i, t), this.itemSizeCacheVersion++;
				let f = !1;
				a ? f = this.applyScrollAdjustment(this.getTotalSize() - c) : d && (f = this.applyScrollAdjustment(s)), this.notify(f), this._retryClampedAdjustment();
			}
		}, this.getVirtualItems = X(() => [this.getVirtualIndexes(), this.getMeasurements()], (e, t) => {
			let n = [];
			for (let r = 0, i = e.length; r < i; r++) {
				let i = t[e[r]];
				n.push(i);
			}
			return n;
		}, {
			key: process.env.NODE_ENV !== "production" && "getVirtualItems",
			debug: () => this.options.debug
		}), this.getVirtualItemForOffset = (e) => {
			let t = this.getMeasurements();
			if (t.length === 0) return;
			let n = this._singleLaneMeasurements?.flat, r = this.options.lanes === 1 && n != null;
			return Kt(t[un(0, t.length - 1, r ? (e) => n[e * 2] : (e) => Kt(t[e]).start, e)]);
		}, this.getMaxScrollOffset = () => {
			if (!this.scrollElement) return 0;
			if ("scrollHeight" in this.scrollElement) return this.options.horizontal ? this.scrollElement.scrollWidth - this.scrollElement.clientWidth : this.scrollElement.scrollHeight - this.scrollElement.clientHeight;
			{
				let e = this.scrollElement.document.documentElement;
				return this.options.horizontal ? e.scrollWidth - this.scrollElement.innerWidth : e.scrollHeight - this.scrollElement.innerHeight;
			}
		}, this.getVirtualDistanceFromEnd = () => Math.max(this.getTotalSize() - this.getSize() - this.getScrollOffset(), 0), this.getDistanceFromEnd = () => Math.max(this.getMaxScrollOffset() - this.getScrollOffset(), 0), this.isAtEnd = (e = this.options.scrollEndThreshold) => this.getDistanceFromEnd() <= e, this.getOffsetForAlignment = (e, t, n = 0) => {
			if (!this.scrollElement) return 0;
			let r = this.getSize(), i = this.getScrollOffset();
			t === "auto" && (t = e >= i + r ? "end" : "start"), t === "center" ? e += (n - r) / 2 : t === "end" && (e -= r);
			let a = this.getMaxScrollOffset();
			return Math.max(Math.min(a, e), 0);
		}, this.getOffsetForIndex = (e, t = "auto") => {
			e = Math.max(0, Math.min(e, this.options.count - 1));
			let n = this.getSize(), r = this.getScrollOffset(), i = this.measurementsCache[e];
			if (!i) return;
			if (t === "auto") {
				if (i.end >= r + n - this.options.scrollPaddingEnd) t = "end";
				else if (i.start <= r + this.options.scrollPaddingStart) t = "start";
				else return [r, t];
			}
			if (t === "end" && e === this.options.count - 1) return [this.getMaxScrollOffset(), t];
			let a = t === "end" ? i.end + this.options.scrollPaddingEnd : i.start - this.options.scrollPaddingStart;
			return [this.getOffsetForAlignment(a, t, i.size), t];
		}, this.scrollToOffset = (e, { align: t = "start", behavior: n = "auto" } = {}) => {
			this._iosDeferredAdjustment = 0;
			let r = this.getOffsetForAlignment(e, t), i = this.now();
			this.scrollState = {
				index: null,
				align: t,
				behavior: n,
				startedAt: i,
				lastTargetOffset: r,
				stableFrames: 0
			}, this._scrollToOffset(r, {
				adjustments: void 0,
				behavior: n
			}), this.scheduleScrollReconcile();
		}, this.scrollToIndex = (e, { align: t = "auto", behavior: n = "auto" } = {}) => {
			this._iosDeferredAdjustment = 0, e = Math.max(0, Math.min(e, this.options.count - 1));
			let r = this.getOffsetForIndex(e, t);
			if (!r) return;
			let [i, a] = r, o = this.now();
			this.scrollState = {
				index: e,
				align: a,
				behavior: n,
				startedAt: o,
				lastTargetOffset: i,
				stableFrames: 0
			}, this._scrollToOffset(i, {
				adjustments: void 0,
				behavior: n
			}), this.scheduleScrollReconcile();
		}, this.scrollBy = (e, { behavior: t = "auto" } = {}) => {
			let n = this.getScrollOffset() + e, r = this.now();
			this.scrollState = {
				index: null,
				align: "start",
				behavior: t,
				startedAt: r,
				lastTargetOffset: n,
				stableFrames: 0
			}, this._scrollToOffset(n, {
				adjustments: void 0,
				behavior: t
			}), this.scheduleScrollReconcile();
		}, this.scrollToEnd = ({ behavior: e = "auto" } = {}) => {
			if (this.options.count > 0) {
				this.scrollToIndex(this.options.count - 1, {
					align: "end",
					behavior: e
				});
				return;
			}
			this.scrollToOffset(Math.max(this.getTotalSize() - this.getSize(), 0), { behavior: e });
		}, this.getTotalSize = () => {
			let e = this.getMeasurements(), t;
			if (e.length === 0) t = this.options.paddingStart;
			else if (this.options.lanes === 1) {
				let n = e.length - 1, r = this._singleLaneMeasurements?.flat;
				t = r == null ? e[n]?.end ?? 0 : r[n * 2] + r[n * 2 + 1];
			} else {
				let n = Array(this.options.lanes).fill(null), r = e.length - 1;
				for (; r >= 0 && n.some((e) => e === null);) {
					let t = e[r];
					n[t.lane] === null && (n[t.lane] = t.end), r--;
				}
				t = Math.max(...n.filter((e) => e !== null));
			}
			return Math.max(t - this.options.scrollMargin + this.options.paddingEnd, 0);
		}, this.takeSnapshot = () => {
			let e = [];
			if (this.itemSizeCache.size === 0) return e;
			let t = this.getMeasurements();
			for (let n of t) n && this.itemSizeCache.has(n.key) && e.push({
				index: n.index,
				key: n.key,
				start: n.start,
				size: n.size,
				end: n.end,
				lane: n.lane
			});
			return e;
		}, this._scrollToOffset = (e, { adjustments: t, behavior: n }) => {
			this._intendedScrollOffset = e + (t ?? 0), this.options.scrollToFn(e, {
				behavior: n,
				adjustments: t
			}, this);
		}, this.measure = () => {
			this.pendingMin = null, this.itemSizeCache.clear(), this.laneAssignments.clear(), this.itemSizeCacheVersion++, this.notify(!1);
		}, this.setOptions(e);
	}
	applyScrollAdjustment(e, t) {
		if (e === 0) return !1;
		if (process.env.NODE_ENV !== "production" && this.options.debug && console.info("correction", e), Xt() && (this.isScrolling || this._iosTouching || this._iosJustTouchEnded)) return this._iosDeferredAdjustment += e, !1;
		{
			let n = this.getScrollOffset() + this.scrollAdjustments + e, r = this.scrollElement, i = r !== null && ("scrollHeight" in r || "document" in r) ? this.getMaxScrollOffset() : null;
			return this._clampedAdjustment = i !== null && n > i + .5 ? {
				target: n,
				maxAtWrite: i
			} : null, this._scrollToOffset(this.getScrollOffset(), {
				adjustments: this.scrollAdjustments += e,
				behavior: t
			}), this.scrollOffset !== null && (this.scrollOffset += this.scrollAdjustments, this.scrollOffset < 0 && (this.scrollOffset = 0), this.scrollAdjustments = 0), !0;
		}
	}
	scheduleScrollReconcile() {
		if (!this.targetWindow) {
			this.scrollState = null;
			return;
		}
		this.rafId ??= this.targetWindow.requestAnimationFrame(() => {
			this.rafId = null, this.reconcileScroll();
		});
	}
	reconcileScroll() {
		if (!this.scrollState || !this.scrollElement) return;
		if (this.now() - this.scrollState.startedAt > 5e3) {
			this.scrollState = null;
			return;
		}
		let e = this.scrollState.index == null ? void 0 : this.getOffsetForIndex(this.scrollState.index, this.scrollState.align), t = e ? e[0] : this.scrollState.lastTargetOffset, n = t !== this.scrollState.lastTargetOffset;
		if (!n && qt(t, this.getScrollOffset())) {
			if (this.scrollState.stableFrames++, this.scrollState.stableFrames >= 1) {
				this.getScrollOffset() !== t && this._scrollToOffset(t, {
					adjustments: void 0,
					behavior: "auto"
				}), this.scrollState = null;
				return;
			}
		} else if (this.scrollState.stableFrames = 0, n) {
			let e = this.getSize() || 600, n = Math.abs(t - this.getScrollOffset()), r = this.scrollState.behavior === "smooth" && n > e;
			this.scrollState.lastTargetOffset = t, r || (this.scrollState.behavior = "auto"), this._scrollToOffset(t, {
				adjustments: void 0,
				behavior: r ? "smooth" : "auto"
			});
		}
		this.scheduleScrollReconcile();
	}
}, un = (e, t, n, r) => {
	for (; e <= t;) {
		let i = (e + t) / 2 | 0, a = n(i);
		if (a < r) e = i + 1;
		else if (a > r) t = i - 1;
		else return i;
	}
	return e > 0 ? e - 1 : 0;
};
function dn(e, t, n) {
	let r = 0;
	for (; r <= t;) {
		let i = (r + t) / 2 | 0, a = e[i * 2];
		if (a < n) r = i + 1;
		else if (a > n) t = i - 1;
		else return i;
	}
	return r > 0 ? r - 1 : 0;
}
function fn(e, t, n, r, i) {
	let a = e.length - 1;
	if (e.length <= r) return {
		startIndex: 0,
		endIndex: a
	};
	if (r === 1 && i !== null) {
		let e = dn(i, a, n), r = e, o = n + t;
		for (; r < a && i[r * 2] + i[r * 2 + 1] < o;) r++;
		return {
			startIndex: e,
			endIndex: r
		};
	}
	let o = un(0, a, (t) => e[t].start, n), s = o;
	if (r === 1) for (; s < a && e[s].end < n + t;) s++;
	else if (r > 1) {
		let i = Array(r).fill(0);
		for (; s < a && i.some((e) => e < n + t);) {
			let t = e[s];
			i[t.lane] = t.end, s++;
		}
		let c = Array(r).fill(n + t);
		for (; o >= 0 && c.some((e) => e >= n);) {
			let t = e[o];
			c[t.lane] = t.start, o--;
		}
		o = Math.max(0, o - o % r), s = Math.min(a, s + (r - 1 - s % r));
	}
	return {
		startIndex: o,
		endIndex: s
	};
}
//#endregion
//#region ../../node_modules/.pnpm/@tanstack+react-virtual@3.14.13_react-dom@19.3.0_react@19.3.0__react@19.3.0/node_modules/@tanstack/react-virtual/dist/esm/index.js
var pn = typeof document < "u" ? t.useLayoutEffect : t.useEffect;
function mn({ useFlushSync: e = !0, directDomUpdates: n = !1, directDomUpdatesMode: r = "transform", ...i }) {
	let a = t.useReducer((e) => e + 1, 0)[1], o = t.useRef({
		enabled: n,
		mode: r,
		container: null,
		lastSize: null,
		lastPositions: /* @__PURE__ */ new WeakMap(),
		prevRange: null
	});
	o.current.enabled = n, o.current.mode = r;
	let s = t.useRef(!1), c = (e) => {
		let t = o.current;
		if (!t.enabled || !t.container) return;
		let n = e.getTotalSize();
		if (n !== t.lastSize) {
			t.lastSize = n;
			let r = e.options.horizontal ? "width" : "height";
			t.container.style[r] = `${n}px`;
		}
	}, l = (e) => {
		let t = o.current;
		if (!t.enabled || !t.container) return;
		c(e);
		let n = !!e.options.horizontal, r = t.mode === "transform", i = n ? "left" : "top", a = e.options.scrollMargin, s = e.getVirtualItems();
		for (let o of s) {
			let s = o.start - a, c = e.elementsCache.get(o.key);
			c && t.lastPositions.get(c) !== s && (t.lastPositions.set(c, s), r ? c.style.transform = n ? `translate3d(${s}px, 0, 0)` : `translate3d(0, ${s}px, 0)` : c.style[i] = `${s}px`);
		}
	}, u = {
		...i,
		onChange: (t, n) => {
			var r;
			let c = o.current, u = !0;
			if (c.enabled) {
				l(t);
				let e = t.range, n = c.prevRange;
				u = !n || n.isScrolling !== t.isScrolling || n.startIndex !== e?.startIndex || n.endIndex !== e?.endIndex, u && (c.prevRange = e ? {
					startIndex: e.startIndex,
					endIndex: e.endIndex,
					isScrolling: t.isScrolling
				} : null);
			}
			u && (e && n && !s.current ? te(a) : a()), (r = i.onChange) == null || r.call(i, t, n);
		}
	}, [d] = t.useState(() => {
		let e = new ln(u), t = e.measureElement;
		return e.measureElement = (e) => {
			s.current = !0;
			try {
				t(e);
			} finally {
				s.current = !1;
			}
		}, Object.assign(e, { containerRef: (t) => {
			let n = o.current;
			if (n.container = t, n.lastSize = null, t && n.enabled) {
				let r = e.getTotalSize();
				n.lastSize = r;
				let i = e.options.horizontal ? "width" : "height";
				t.style[i] = `${r}px`;
			}
		} });
	});
	return d.setOptions(u), pn(() => d._didMount(), []), pn(() => (c(d), d._willUpdate())), pn(() => {
		l(d);
	}), d;
}
function hn(e) {
	return mn({
		observeElementRect: en,
		observeElementOffset: an,
		scrollToFn: sn,
		...e
	});
}
//#endregion
//#region src/table/theme.ts
var Z = /^#[0-9a-fA-F]{6}$/;
function gn(e) {
	if (!e || typeof e != "object") return {};
	let t = e, n = (e) => typeof e == "string" && Z.test(e) ? e : void 0;
	return {
		headerColor: n(t.headerColor),
		rowLightColor: n(t.rowLightColor),
		rowDarkColor: n(t.rowDarkColor),
		highlightColor: n(t.highlightColor),
		cellTextColor: n(t.cellTextColor)
	};
}
function _n(e) {
	let t = {};
	return e ? (e.headerColor && Z.test(e.headerColor) && (t["--table-header-bg"] = e.headerColor), e.rowLightColor && Z.test(e.rowLightColor) && (t["--table-row-light"] = e.rowLightColor), e.rowDarkColor && Z.test(e.rowDarkColor) && (t["--table-row-dark"] = e.rowDarkColor), e.highlightColor && Z.test(e.highlightColor) && (t["--table-row-highlight"] = e.highlightColor), e.cellTextColor && Z.test(e.cellTextColor) && (t["--table-cell-text"] = e.cellTextColor), t) : t;
}
//#endregion
//#region src/table/table-filters.ts
function vn() {
	return {
		combinator: "AND",
		rules: []
	};
}
var yn = [
	"contains",
	"notContains",
	"equals",
	"notEquals",
	"startsWith",
	"endsWith",
	"isEmpty"
], bn = [
	"equals",
	"notEquals",
	"gt",
	"gte",
	"lt",
	"lte",
	"between"
], xn = [
	"is",
	"before",
	"after",
	"between"
], Sn = [
	"number",
	"currency",
	"duration",
	"progress",
	"progressFull"
];
function Cn(e) {
	return e === "datetime" ? xn : Sn.includes(e) ? bn : yn;
}
function wn(e) {
	return e !== "isEmpty";
}
function Tn(e) {
	return e === "between";
}
function Q(e) {
	return !e.columnId || !e.operator ? !1 : !wn(e.operator) || !(e.value === "" || Tn(e.operator) && (e.value2 ?? "") === "");
}
function En(e) {
	return e ? e.rules.filter(Q).length : 0;
}
function Dn() {
	return typeof crypto < "u" && "randomUUID" in crypto ? crypto.randomUUID() : `rule-${Math.random().toString(36).slice(2)}-${Date.now()}`;
}
function On(e) {
	if (!e) return null;
	let t = e.rules.filter(Q).map(({ columnId: e, operator: t, value: n, value2: r }) => ({
		columnId: e,
		operator: t,
		value: n,
		...r !== void 0 && { value2: r }
	}));
	return t.length === 0 ? null : JSON.stringify({
		combinator: e.combinator,
		rules: t
	});
}
function kn(e) {
	if (!e) return null;
	try {
		let t = JSON.parse(e);
		if (!Array.isArray(t.rules)) return null;
		let n = t.combinator === "OR" ? "OR" : "AND", r = [];
		for (let e of t.rules) {
			if (!e || typeof e != "object") continue;
			let t = e;
			typeof t.columnId == "string" && typeof t.operator == "string" && typeof t.value == "string" && r.push({
				id: Dn(),
				columnId: t.columnId,
				operator: t.operator,
				value: t.value,
				...typeof t.value2 == "string" && { value2: t.value2 }
			});
		}
		return r.length === 0 ? null : {
			combinator: n,
			rules: r
		};
	} catch {
		return null;
	}
}
var An = (e) => {
	let t = new Date(e).getTime();
	return Number.isNaN(t) ? null : t;
};
function jn(e) {
	let t = new Date(e);
	return Number.isNaN(t.getTime()) ? null : (t.setHours(0, 0, 0, 0), t.getTime());
}
function Mn(e, t, n) {
	let r = e[t.columnId];
	if (t.operator === "isEmpty") return r == null || r === "";
	if (n === "datetime") {
		let e = An(r);
		if (e === null) return !1;
		let n = !Number.isNaN(Number(t.value)) && t.value !== "", i = n ? Number(t.value) : jn(t.value);
		if (i === null) return !1;
		let a = n ? i : i + 86399999;
		switch (t.operator) {
			case "is": return e >= i && e <= a;
			case "before": return e < i;
			case "after": return e > a;
			case "between": {
				let n = jn(t.value2 ?? "");
				if (n === null) return !1;
				let r = Math.min(i, n), a = Math.max(i + 86399999, n + 86399999);
				return e >= r && e <= a;
			}
			default: return !1;
		}
	}
	if (Sn.includes(n)) {
		let e = Number(r);
		if (Number.isNaN(e)) return !1;
		let n = Number(t.value);
		if (Number.isNaN(n)) return !1;
		switch (t.operator) {
			case "equals": return e === n;
			case "notEquals": return e !== n;
			case "gt": return e > n;
			case "gte": return e >= n;
			case "lt": return e < n;
			case "lte": return e <= n;
			case "between": {
				let r = Number(t.value2);
				return !Number.isNaN(r) && e >= Math.min(n, r) && e <= Math.max(n, r);
			}
			default: return !1;
		}
	}
	let i = r == null ? "" : String(r), a = t.value;
	switch (t.operator) {
		case "contains": return i.toLowerCase().includes(a.toLowerCase());
		case "notContains": return !i.toLowerCase().includes(a.toLowerCase());
		case "equals": return i === a;
		case "notEquals": return i !== a;
		case "startsWith": return i.startsWith(a);
		case "endsWith": return i.endsWith(a);
		default: return !1;
	}
}
function Nn(e, t, n) {
	if (!t) return e;
	let r = t.rules.filter(Q);
	return r.length === 0 ? e : e.filter((e) => {
		let i = r.map((t) => Mn(e, t, n[t.columnId] ?? "text"));
		return t.combinator === "OR" ? i.some(Boolean) : i.every(Boolean);
	});
}
//#endregion
//#region src/table/FilterModal.tsx
var Pn = {
	contains: "opContains",
	notContains: "opNotContains",
	equals: "opEquals",
	notEquals: "opNotEquals",
	startsWith: "opStartsWith",
	endsWith: "opEndsWith",
	isEmpty: "opIsEmpty",
	gt: "opGt",
	gte: "opGte",
	lt: "opLt",
	lte: "opLte",
	between: "opBetween",
	is: "opIs",
	before: "opBefore",
	after: "opAfter"
};
function Fn(e, t) {
	return Y(Pn[e], t);
}
var In = "inline-flex h-8 cursor-pointer items-center gap-1.5 rounded-md border border-input bg-background px-2.5 text-xs font-medium text-foreground hover:bg-accent hover:text-accent-foreground";
function Ln(e) {
	return {
		id: Dn(),
		columnId: e[0]?.id ?? "",
		operator: Cn(e[0]?.display ?? "text")[0],
		value: ""
	};
}
var Rn = "h-8 rounded-md border border-input bg-background px-2 text-xs text-foreground focus:outline-none focus:ring-1 focus:ring-ring", zn = "h-8 min-w-0 flex-1 rounded-md border border-input bg-background px-2 text-xs text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-ring";
function Bn(e) {
	return e === "datetime" ? "date" : e === "text" ? "text" : "number";
}
function Vn({ columns: e, filterState: t, onApply: n, locale: r }) {
	let i = r ?? gt(void 0), [a, o] = d(!1), [s, c] = d(t), l = En(t), u = () => {
		c(structuredClone(t)), o(!0);
	}, h = (e, t) => {
		c((n) => ({
			...n,
			rules: n.rules.map((n) => n.id === e ? {
				...n,
				...t
			} : n)
		}));
	}, g = (t, n) => {
		let r = Cn(e.find((e) => e.id === n)?.display ?? "text"), i = r.includes(t.operator) ? t.operator : r[0];
		h(t.id, {
			columnId: n,
			operator: i,
			value: "",
			value2: void 0
		});
	}, _ = (e, t) => {
		h(e.id, {
			operator: t,
			value2: Tn(t) ? e.value2 : void 0
		});
	}, v = (e) => {
		c((t) => ({
			...t,
			rules: t.rules.filter((t) => t.id !== e)
		}));
	};
	return /* @__PURE__ */ m(f, { children: [/* @__PURE__ */ m("button", {
		type: "button",
		className: In,
		onClick: u,
		"data-testid": "table-filter-button",
		children: [
			/* @__PURE__ */ p(Hn, { className: "h-3.5 w-3.5" }),
			Y("filter", i),
			l > 0 && /* @__PURE__ */ p("span", {
				className: "inline-flex h-4 min-w-4 items-center justify-center rounded-full bg-primary px-1 text-[10px] font-medium text-primary-foreground",
				"data-testid": "table-filter-count",
				children: l
			})
		]
	}), a && /* @__PURE__ */ m("div", {
		className: "fixed inset-0 z-[60] flex items-center justify-center bg-black/40 p-4",
		children: [/* @__PURE__ */ p("div", {
			className: "absolute inset-0",
			onClick: () => o(!1),
			"aria-hidden": "true"
		}), /* @__PURE__ */ m("div", {
			role: "dialog",
			"aria-label": Y("filters", i),
			"data-testid": "table-filter-modal",
			className: "relative flex max-h-[90dvh] w-full max-w-2xl flex-col gap-4 rounded-lg border border-border bg-card p-4 shadow-lg sm:p-6",
			children: [
				/* @__PURE__ */ m("div", { children: [/* @__PURE__ */ p("h3", {
					className: "text-sm font-semibold text-foreground",
					children: Y("filters", i)
				}), /* @__PURE__ */ p("p", {
					className: "mt-1 text-xs text-muted-foreground",
					children: Y("filtersDescription", i)
				})] }),
				/* @__PURE__ */ m("div", {
					className: "flex items-center gap-2",
					children: [/* @__PURE__ */ p("span", {
						className: "text-xs text-muted-foreground",
						children: Y("match", i)
					}), /* @__PURE__ */ p("div", {
						className: "inline-flex overflow-hidden rounded-md border border-input",
						children: ["AND", "OR"].map((e) => /* @__PURE__ */ p("button", {
							type: "button",
							onClick: () => c((t) => ({
								...t,
								combinator: e
							})),
							className: `cursor-pointer px-3 py-1 text-xs font-medium transition-colors ${s.combinator === e ? "bg-primary text-primary-foreground" : "bg-background text-foreground hover:bg-accent"}`,
							children: e
						}, e))
					})]
				}),
				/* @__PURE__ */ m("div", {
					className: "min-h-0 flex-1 space-y-2 overflow-y-auto",
					children: [s.rules.length === 0 && /* @__PURE__ */ p("p", {
						className: "py-6 text-center text-xs text-muted-foreground",
						children: Y("noConditions", i)
					}), s.rules.map((t, n) => {
						let r = e.find((e) => e.id === t.columnId)?.display ?? "text", a = Cn(r), o = wn(t.operator), s = Tn(t.operator), c = Bn(r);
						return /* @__PURE__ */ m("div", {
							"data-testid": "table-filter-rule",
							className: "flex flex-wrap items-center gap-2",
							children: [
								/* @__PURE__ */ m("span", {
									className: "text-xs text-muted-foreground",
									children: [n + 1, "."]
								}),
								/* @__PURE__ */ p("select", {
									value: t.columnId,
									onChange: (e) => g(t, e.target.value),
									className: `${Rn} w-[160px] flex-none`,
									"aria-label": Y("filterColumn", i),
									children: e.map((e) => /* @__PURE__ */ p("option", {
										value: e.id,
										children: e.header
									}, e.id))
								}),
								/* @__PURE__ */ p("select", {
									value: t.operator,
									onChange: (e) => _(t, e.target.value),
									className: `${Rn} w-[150px] flex-none`,
									"aria-label": Y("filterOperator", i),
									children: a.map((e) => /* @__PURE__ */ p("option", {
										value: e,
										children: Fn(e, i)
									}, e))
								}),
								o && /* @__PURE__ */ p("input", {
									type: c,
									value: t.value,
									onChange: (e) => h(t.id, { value: e.target.value }),
									placeholder: Y(s ? "fromPlaceholder" : "valuePlaceholder", i),
									className: zn
								}),
								s && /* @__PURE__ */ p("input", {
									type: c,
									value: t.value2 ?? "",
									onChange: (e) => h(t.id, { value2: e.target.value }),
									placeholder: Y("toPlaceholder", i),
									className: zn
								}),
								/* @__PURE__ */ p("button", {
									type: "button",
									onClick: () => v(t.id),
									"aria-label": Y("removeCondition", i),
									className: "inline-flex h-7 w-7 flex-none cursor-pointer items-center justify-center rounded-md text-muted-foreground hover:bg-accent hover:text-foreground",
									children: /* @__PURE__ */ p(Wn, { className: "h-3.5 w-3.5" })
								})
							]
						}, t.id);
					})]
				}),
				/* @__PURE__ */ p("div", { children: /* @__PURE__ */ m("button", {
					type: "button",
					className: "inline-flex h-8 cursor-pointer items-center gap-1.5 rounded-md border border-input bg-background px-2.5 text-xs font-medium text-foreground hover:bg-accent hover:text-accent-foreground",
					onClick: () => {
						c((t) => ({
							...t,
							rules: [...t.rules, Ln(e)]
						}));
					},
					"data-testid": "table-filter-add-condition",
					children: [/* @__PURE__ */ p(Un, { className: "h-3.5 w-3.5" }), Y("addCondition", i)]
				}) }),
				/* @__PURE__ */ m("div", {
					className: "flex flex-row justify-end gap-2",
					children: [
						/* @__PURE__ */ p("button", {
							type: "button",
							className: "inline-flex h-8 cursor-pointer items-center rounded-md px-3 text-xs font-medium text-foreground hover:bg-accent",
							onClick: () => {
								c(vn());
							},
							children: Y("clearAll", i)
						}),
						/* @__PURE__ */ p("button", {
							type: "button",
							className: "inline-flex h-8 cursor-pointer items-center rounded-md border border-input bg-background px-3 text-xs font-medium text-foreground hover:bg-accent",
							onClick: () => o(!1),
							children: Y("cancel", i)
						}),
						/* @__PURE__ */ p("button", {
							type: "button",
							className: "inline-flex h-8 cursor-pointer items-center rounded-md bg-primary px-3 text-xs font-medium text-primary-foreground hover:bg-primary/90",
							onClick: () => {
								let e = s.rules.filter(Q).map((e) => ({
									...e,
									value2: Tn(e.operator) ? e.value2 : void 0
								}));
								n(e.length > 0 ? {
									combinator: s.combinator,
									rules: e
								} : null), o(!1);
							},
							"data-testid": "table-filter-apply",
							children: Y("apply", i)
						})
					]
				})
			]
		})]
	})] });
}
function Hn({ className: e }) {
	return /* @__PURE__ */ p("svg", {
		className: e,
		viewBox: "0 0 24 24",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: "2",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		"aria-hidden": "true",
		children: /* @__PURE__ */ p("polygon", { points: "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" })
	});
}
function Un({ className: e }) {
	return /* @__PURE__ */ m("svg", {
		className: e,
		viewBox: "0 0 24 24",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: "2",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		"aria-hidden": "true",
		children: [/* @__PURE__ */ p("path", { d: "M5 12h14" }), /* @__PURE__ */ p("path", { d: "M12 5v14" })]
	});
}
function Wn({ className: e }) {
	return /* @__PURE__ */ m("svg", {
		className: e,
		viewBox: "0 0 24 24",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: "2",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		"aria-hidden": "true",
		children: [
			/* @__PURE__ */ p("path", { d: "M3 6h18" }),
			/* @__PURE__ */ p("path", { d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" }),
			/* @__PURE__ */ p("path", { d: "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" })
		]
	});
}
//#endregion
//#region src/table/ColumnSettings.tsx
function Gn({ table: e, locale: t }) {
	let [n, r] = d(!1);
	return /* @__PURE__ */ m(f, { children: [/* @__PURE__ */ m("button", {
		type: "button",
		className: In,
		onClick: () => r((e) => !e),
		"aria-expanded": n,
		"aria-haspopup": "true",
		"data-testid": "table-settings-button",
		children: [/* @__PURE__ */ p(Kn, { className: "h-3.5 w-3.5" }), Y("settings", t)]
	}), n && /* @__PURE__ */ m(f, { children: [/* @__PURE__ */ p("div", {
		className: "fixed inset-0 z-40",
		onClick: () => r(!1),
		"aria-hidden": "true"
	}), /* @__PURE__ */ m("div", {
		"data-testid": "table-settings-panel",
		className: "absolute right-0 top-full z-50 mt-1 w-72 rounded-md border border-border bg-card p-2 shadow-lg",
		children: [
			/* @__PURE__ */ p("p", {
				className: "px-2 pb-1 pt-1.5 text-xs font-semibold text-foreground",
				children: Y("pinColumns", t)
			}),
			/* @__PURE__ */ p("p", {
				className: "px-2 pb-2 text-[11px] leading-snug text-muted-foreground",
				children: Y("pinColumnsDescription", t)
			}),
			/* @__PURE__ */ p("div", {
				className: "max-h-72 overflow-y-auto",
				children: e.getAllLeafColumns().map((e) => {
					let n = e.getIsPinned(), r = n === "start", i = n === "end";
					return /* @__PURE__ */ m("div", {
						"data-testid": `table-settings-column-${e.id}`,
						className: "flex items-center justify-between gap-2 rounded px-2 py-1.5 hover:bg-accent/50",
						children: [/* @__PURE__ */ p("span", {
							className: "min-w-0 truncate text-xs font-medium text-foreground",
							children: typeof e.columnDef.header == "string" ? e.columnDef.header : e.id
						}), /* @__PURE__ */ m("div", {
							className: "flex flex-none items-center gap-1",
							children: [/* @__PURE__ */ p("button", {
								type: "button",
								title: Y("pinLeft", t),
								"aria-label": Y("pinLeftAria", t, { column: e.id }),
								onClick: () => e.pin(!r && "start"),
								className: `inline-flex h-6 w-6 cursor-pointer items-center justify-center rounded ${r ? "bg-primary/10 text-primary" : "text-muted-foreground hover:bg-accent hover:text-foreground"}`,
								children: /* @__PURE__ */ p(qn, { className: "h-3.5 w-3.5" })
							}), /* @__PURE__ */ p("button", {
								type: "button",
								title: Y("pinRight", t),
								"aria-label": Y("pinRightAria", t, { column: e.id }),
								onClick: () => e.pin(!i && "end"),
								className: `inline-flex h-6 w-6 cursor-pointer items-center justify-center rounded ${i ? "bg-primary/10 text-primary" : "text-muted-foreground hover:bg-accent hover:text-foreground"}`,
								children: /* @__PURE__ */ p(qn, { className: "h-3.5 w-3.5 -scale-x-100" })
							})]
						})]
					}, e.id);
				})
			})
		]
	})] })] });
}
function Kn({ className: e }) {
	return /* @__PURE__ */ m("svg", {
		className: e,
		viewBox: "0 0 24 24",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: "2",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		"aria-hidden": "true",
		children: [
			/* @__PURE__ */ p("path", { d: "M4 21v-7" }),
			/* @__PURE__ */ p("path", { d: "M4 10V3" }),
			/* @__PURE__ */ p("path", { d: "M12 21v-9" }),
			/* @__PURE__ */ p("path", { d: "M12 8V3" }),
			/* @__PURE__ */ p("path", { d: "M20 21v-5" }),
			/* @__PURE__ */ p("path", { d: "M20 12V3" }),
			/* @__PURE__ */ p("path", { d: "M2 14h4" }),
			/* @__PURE__ */ p("path", { d: "M10 8h4" }),
			/* @__PURE__ */ p("path", { d: "M18 16h4" })
		]
	});
}
function qn({ className: e }) {
	return /* @__PURE__ */ m("svg", {
		className: e,
		viewBox: "0 0 24 24",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: "2",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		"aria-hidden": "true",
		children: [/* @__PURE__ */ p("line", {
			x1: "12",
			y1: "17",
			x2: "12",
			y2: "22"
		}), /* @__PURE__ */ p("path", { d: "M5 17h14v-4a2 2 0 0 0-.59-1.41L16 9V4a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v5l-2.41 2.59A2 2 0 0 0 5 13z" })]
	});
}
//#endregion
//#region src/table/presets.ts
var Jn = {
	default: {
		density: "standard",
		sorting: { enabled: !0 },
		columnResize: { enabled: !0 }
	},
	compact: {
		density: "compact",
		sorting: { enabled: !0 },
		columnResize: { enabled: !0 }
	},
	infiniteScroll: {
		infiniteScroll: {
			enabled: !0,
			thresholdPx: 200
		},
		sorting: {
			enabled: !0,
			manual: !0
		},
		columnResize: { enabled: !0 }
	},
	fixedFooter: { footerTotals: {
		enabled: !0,
		label: "Total"
	} },
	autoFitColumns: { columnResize: { enabled: !0 } }
}, Yn = {
	density: "standard",
	sorting: { enabled: !0 },
	selection: { enabled: !1 },
	footerTotals: { enabled: !1 },
	infiniteScroll: { enabled: !1 },
	columnResize: { enabled: !0 },
	virtualization: { enabled: !1 },
	columnSettings: { enabled: !1 },
	filtering: { enabled: !1 },
	export: {
		enabled: !1,
		formats: ["csv", "xlsx"]
	},
	locale: "en-US"
};
function Xn({ config: e }) {
	let t = ge(e), n = _e(t);
	if (!n.valid) throw Error(`[table] invalid config: ${n.errors.join("; ")}`);
	let r = t.preset, i = null;
	if (r) {
		let e = Jn[r];
		if (!e) throw Error(`[table] unknown preset "${r}"`);
		i = e;
	}
	let a = z(he({
		defaults: Yn,
		preset: i ? {
			name: r,
			options: i
		} : null,
		config: t
	})), o = gt(a.locale);
	return a.emptyMessage = a.emptyMessage ?? Y("empty", o), a.loadingMessage = a.loadingMessage ?? Y("loading", o), a.loadingMoreMessage = a.loadingMoreMessage ?? Y("loadingMore", o), {
		config: a,
		columns: Zn(a)
	};
}
function Zn(e) {
	return e.columns.map((t) => Qn(t, e));
}
function Qn(e, t) {
	let n = t.sorting === !1 ? !1 : e.sortable ?? t.sorting?.enabled ?? !0;
	return {
		id: e.id,
		accessorKey: e.id,
		header: e.header,
		enableSorting: n,
		size: e.width,
		minSize: e.minWidth ?? 40,
		maxSize: e.maxWidth,
		meta: { columnConfig: e },
		footer: e.id
	};
}
function $n(e, t, n = {}) {
	if (e == null || e === "") return "";
	let r = n.locale ?? "en-US";
	switch (t) {
		case "datetime": return er(e, r);
		case "currency": return new Intl.NumberFormat(r, {
			style: "currency",
			currency: n.currency ?? "USD"
		}).format(Number(e));
		case "number": return new Intl.NumberFormat(r).format(Number(e));
		case "duration": return tr(Number(e));
		case "progress":
		case "progressFull": return `${Math.round(nr(e))}%`;
		case "progressColumn": return n.labelFormat === "compact" ? rr(Number(e), r) : new Intl.NumberFormat(r).format(Number(e));
		default: return String(e);
	}
}
function er(e, t) {
	let n = e instanceof Date ? e : new Date(String(e));
	return Number.isNaN(n.getTime()) ? String(e) : new Intl.DateTimeFormat(t, {
		year: "numeric",
		month: "2-digit",
		day: "2-digit",
		hour: "2-digit",
		minute: "2-digit",
		hour12: !1
	}).format(n);
}
function tr(e) {
	if (!Number.isFinite(e)) return "";
	let t = e < 0 ? "-" : "", n = Math.abs(Math.round(e)), r = Math.floor(n / 3600), i = Math.floor(n % 3600 / 60), a = n % 60;
	return `${t}${r}:${String(i).padStart(2, "0")}:${String(a).padStart(2, "0")}`;
}
function nr(e) {
	let t = Number(e);
	if (!Number.isFinite(t)) return 0;
	let n = t <= 1 ? t * 100 : t;
	return Math.min(100, Math.max(0, n));
}
function rr(e, t = "en") {
	return Number.isFinite(e) ? new Intl.NumberFormat(t, {
		notation: "compact",
		compactDisplay: "short",
		maximumFractionDigits: 2
	}).format(e) : "";
}
function ir(e, t) {
	return !Number.isFinite(t) || t <= 0 ? 0 : Math.max(0, Math.min(e / t, 1));
}
function ar(e, t) {
	if (t === "count") return e.length;
	let n = e.reduce((e, t) => e + (Number(t) || 0), 0);
	return t === "avg" && e.length > 0 ? n / e.length : n;
}
//#endregion
//#region src/table/export.ts
function or(e) {
	let t = e.columns.filter((e) => e.hide !== !0);
	return {
		headers: t.map((e) => e.header),
		rows: e.rows.map((n) => t.map((t) => $n(n[t.id], t.display ?? e.displays?.[t.id], {
			locale: e.locale,
			currency: e.currency
		})))
	};
}
function sr(e) {
	return /[",\r\n]/.test(e) ? `"${e.replaceAll("\"", "\"\"")}"` : e;
}
function cr(e) {
	let t = or(e);
	return [t.headers, ...t.rows].map((e) => e.map(sr).join(",")).join("\r\n");
}
var lr = (() => {
	let e = /* @__PURE__ */ new Uint32Array(256);
	for (let t = 0; t < 256; t++) {
		let n = t;
		for (let e = 0; e < 8; e++) n = n & 1 ? 3988292384 ^ n >>> 1 : n >>> 1;
		e[t] = n >>> 0;
	}
	return e;
})();
function ur(e) {
	let t = 4294967295;
	for (let n of e) t = lr[(t ^ n) & 255] ^ t >>> 8;
	return (t ^ 4294967295) >>> 0;
}
var dr = class {
	chunks = [];
	u16(e) {
		return this.chunks.push(e & 255, e >>> 8 & 255), this;
	}
	u32(e) {
		return this.chunks.push(e & 255, e >>> 8 & 255, e >>> 16 & 255, e >>> 24 & 255), this;
	}
	bytes(e) {
		for (let t of e) this.chunks.push(t);
		return this;
	}
	ascii(e) {
		for (let t = 0; t < e.length; t++) this.chunks.push(e.charCodeAt(t) & 255);
		return this;
	}
	toUint8Array() {
		return Uint8Array.from(this.chunks);
	}
};
function fr(e) {
	let t = new dr(), n = new dr();
	for (let r of e) {
		let e = new TextEncoder().encode(r.name), i = ur(r.data), a = t.toUint8Array().length;
		t.u32(67324752), t.u16(20), t.u16(0), t.u16(0), t.u16(0), t.u16(33), t.u32(i), t.u32(r.data.length), t.u32(r.data.length), t.u16(e.length), t.u16(0), t.bytes(e), t.bytes(r.data), n.u32(33639248), n.u16(20), n.u16(20), n.u16(0), n.u16(0), n.u16(0), n.u16(33), n.u32(i), n.u32(r.data.length), n.u32(r.data.length), n.u16(e.length), n.u16(0), n.u16(0), n.u16(0), n.u16(0), n.u32(0), n.u32(a), n.bytes(e);
	}
	let r = n.toUint8Array(), i = new dr();
	i.u32(101010256), i.u16(0), i.u16(0), i.u16(e.length), i.u16(e.length), i.u32(r.length), i.u32(t.toUint8Array().length), i.u16(0);
	let a = new dr();
	return a.bytes(t.toUint8Array()), a.bytes(r), a.bytes(i.toUint8Array()), a.toUint8Array();
}
function pr(e) {
	return e.replaceAll("&", "&amp;").replaceAll("<", "&lt;").replaceAll(">", "&gt;").replaceAll("\"", "&quot;");
}
function mr(e) {
	let t = "", n = e;
	for (; n >= 0;) t = String.fromCharCode(65 + n % 26) + t, n = Math.floor(n / 26) - 1;
	return t;
}
function hr(e) {
	if (e.trim() === "") return !1;
	let t = e.replaceAll(",", "");
	return t !== "" && !Number.isNaN(Number(t));
}
function gr(e, t) {
	let n = (e) => pr(e.length > 32767 ? e.slice(0, 32767) : e), r = [], i = e.headers.map((e, t) => typeof e == "string" && e !== "" && !hr(e) ? `<c r="${mr(t)}1" t="inlineStr"><is><t>${n(e)}</t></is></c>` : `<c r="${mr(t)}1"><v>${pr(e)}</v></c>`).join("");
	return r.push(`<row r="1">${i}</row>`), e.rows.forEach((e, t) => {
		let i = e.map((e, r) => {
			let i = `${mr(r)}${t + 2}`;
			return e !== "" && hr(e) ? `<c r="${i}"><v>${e.replaceAll(",", "")}</v></c>` : e === "" ? "" : `<c r="${i}" t="inlineStr"><is><t xml:space="preserve">${n(e)}</t></is></c>`;
		}).join("");
		r.push(`<row r="${t + 2}">${i}</row>`);
	}), `<?xml version="1.0" encoding="UTF-8" standalone="yes"?><worksheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships"><sheetData>${r.join("")}</sheetData>` + (t ? "<drawing r:id=\"rId1\"/>" : "") + "</worksheet>";
}
function _r(e) {
	return xr(or(e));
}
var vr = 9525;
function yr(e) {
	if (e.length < 24 || e[0] !== 137 || e[1] !== 80 || e[2] !== 78 || e[3] !== 71) return null;
	let t = new DataView(e.buffer, e.byteOffset, e.byteLength);
	return {
		width: t.getUint32(16),
		height: t.getUint32(20)
	};
}
function br(e) {
	return `<?xml version="1.0" encoding="UTF-8" standalone="yes"?><xdr:wsDr xmlns:xdr="http://schemas.openxmlformats.org/drawingml/2006/spreadsheetDrawing" xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships"><xdr:oneCellAnchor><xdr:from><xdr:col>${e.fromCol}</xdr:col><xdr:colOff>0</xdr:colOff><xdr:row>${e.fromRow}</xdr:row><xdr:rowOff>0</xdr:rowOff></xdr:from><xdr:ext cx="${e.widthEmu}" cy="${e.heightEmu}"/><xdr:pic><xdr:nvPicPr><xdr:cNvPr id="1" name="Chart"/><xdr:cNvPicPr/></xdr:nvPicPr><xdr:blipFill><a:blip r:embed="rId1"/><a:stretch><a:fillRect/></a:stretch></xdr:blipFill><xdr:spPr><a:xfrm><a:off x="0" y="0"/><a:ext cx="${e.widthEmu}" cy="${e.heightEmu}"/></a:xfrm><a:prstGeom prst="rect"><a:avLst/></a:prstGeom></xdr:spPr></xdr:pic><xdr:clientData/></xdr:oneCellAnchor></xdr:wsDr>`;
}
function xr(e, t) {
	let n = new TextEncoder(), r = t != null && t.data.length > 0, i = "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"yes\"?><Types xmlns=\"http://schemas.openxmlformats.org/package/2006/content-types\"><Default Extension=\"rels\" ContentType=\"application/vnd.openxmlformats-package.relationships+xml\"/><Default Extension=\"xml\" ContentType=\"application/xml\"/>" + (r ? "<Default Extension=\"png\" ContentType=\"image/png\"/><Override PartName=\"/xl/drawings/drawing1.xml\" ContentType=\"application/vnd.openxmlformats-officedocument.drawing+xml\"/>" : "") + "<Override PartName=\"/xl/workbook.xml\" ContentType=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml\"/><Override PartName=\"/xl/worksheets/sheet1.xml\" ContentType=\"application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml\"/></Types>", a = gr(e, r), o = [
		{
			name: "[Content_Types].xml",
			data: n.encode(i)
		},
		{
			name: "_rels/.rels",
			data: n.encode("<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"yes\"?><Relationships xmlns=\"http://schemas.openxmlformats.org/package/2006/relationships\"><Relationship Id=\"rId1\" Type=\"http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument\" Target=\"xl/workbook.xml\"/></Relationships>")
		},
		{
			name: "xl/workbook.xml",
			data: n.encode("<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"yes\"?><workbook xmlns=\"http://schemas.openxmlformats.org/spreadsheetml/2006/main\" xmlns:r=\"http://schemas.openxmlformats.org/officeDocument/2006/relationships\"><sheets><sheet name=\"Data\" sheetId=\"1\" r:id=\"rId1\"/></sheets></workbook>")
		},
		{
			name: "xl/_rels/workbook.xml.rels",
			data: n.encode("<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"yes\"?><Relationships xmlns=\"http://schemas.openxmlformats.org/package/2006/relationships\"><Relationship Id=\"rId1\" Type=\"http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet\" Target=\"worksheets/sheet1.xml\"/></Relationships>")
		},
		{
			name: "xl/worksheets/sheet1.xml",
			data: n.encode(a)
		}
	];
	if (r && t) {
		let r = yr(t.data), i = t.widthPx ?? 640, a = Math.round(r ? i * r.height / r.width : i * 9 / 16), s = br({
			fromCol: t.fromCol ?? e.headers.length + 1,
			fromRow: t.fromRow ?? 0,
			widthEmu: i * vr,
			heightEmu: a * vr
		});
		o.push({
			name: "xl/media/image1.png",
			data: t.data
		}, {
			name: "xl/drawings/drawing1.xml",
			data: n.encode(s)
		}, {
			name: "xl/drawings/_rels/drawing1.xml.rels",
			data: n.encode("<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"yes\"?><Relationships xmlns=\"http://schemas.openxmlformats.org/package/2006/relationships\"><Relationship Id=\"rId1\" Type=\"http://schemas.openxmlformats.org/officeDocument/2006/relationships/image\" Target=\"../media/image1.png\"/></Relationships>")
		}, {
			name: "xl/worksheets/_rels/sheet1.xml.rels",
			data: n.encode("<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"yes\"?><Relationships xmlns=\"http://schemas.openxmlformats.org/package/2006/relationships\"><Relationship Id=\"rId1\" Type=\"http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing\" Target=\"../drawings/drawing1.xml\"/></Relationships>")
		});
	}
	return fr(o);
}
function Sr(e, t) {
	if (typeof document > "u") throw Error("[table] export requires a DOM document");
	let n = URL.createObjectURL(e), r = document.createElement("a");
	r.href = n, r.download = t, document.body.appendChild(r), r.click(), document.body.removeChild(r), URL.revokeObjectURL(n);
}
function Cr(e) {
	Sr(new Blob([`\uFEFF${cr(e)}`], { type: "text/csv;charset=utf-8;" }), `${e.fileName ?? "table"}.csv`);
}
function wr(e) {
	Sr(new Blob([_r(e)], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), `${e.fileName ?? "table"}.xlsx`);
}
//#endregion
//#region src/table/features.ts
var Tr = k({
	rowSortingFeature: w,
	columnOrderingFeature: h,
	columnPinningFeature: g,
	columnVisibilityFeature: y,
	rowSelectionFeature: C,
	columnResizingFeature: _,
	columnSizingFeature: v,
	sortedRowModel: b(),
	sortFns: {
		basic: E,
		text: O,
		alphanumeric: T,
		datetime: D
	},
	columnMeta: S()
});
//#endregion
//#region src/table/DataTable.tsx
function $(...e) {
	return e.filter(Boolean).join(" ");
}
var Er = {
	compact: 32,
	standard: 40,
	comfortable: 48
}, Dr = {
	compact: "px-2",
	standard: "px-2",
	comfortable: "px-2"
}, Or = {
	compact: "h-8 px-2",
	standard: "h-10 px-2",
	comfortable: "h-12 px-2"
}, kr = {
	left: "text-left",
	center: "text-center",
	right: "text-right"
};
function Ar(e, t) {
	return e ? {
		position: "sticky",
		left: e === "start" ? t : void 0,
		right: e === "end" ? t : void 0,
		zIndex: 10
	} : {
		position: "relative",
		zIndex: 1
	};
}
function jr(e, t) {
	if (e) return "inset -1px 0 0 hsl(var(--border)), -4px 0 4px -4px hsl(var(--border))";
	if (t) return "inset 1px 0 0 hsl(var(--border)), 4px 0 4px -4px hsl(var(--border))";
}
function Mr({ data: e, config: t, loadingMore: n, selectedIds: r, onSelectionChange: i, onRowClick: a, onSortingChange: o, onFilterChange: c, onScrollNearBottom: f, className: h }) {
	let g = l(() => Xn({ config: t }), [t]), _ = g.config, v = _.sorting !== !1 && (_.sorting?.enabled ?? !0), y = _.sorting === !1 ? void 0 : _.sorting, b = v && y?.manual === !0, S = _.selection === !1 ? void 0 : _.selection, C = S?.enabled === !0, w = _.footerTotals === !1 ? void 0 : _.footerTotals, T = _.infiniteScroll === !1 ? void 0 : _.infiniteScroll, E = _.columnResize === !1 ? void 0 : _.columnResize, D = _.density ?? "standard", O = S?.idField ?? _.idField, k = gt(_.locale), te = _.columnSettings === !0 || _.columnSettings !== !1 && _.columnSettings?.enabled === !0, j = _.filtering === !1 ? void 0 : _.filtering, M = j === !0 || j?.enabled === !0, ne = _.export === !0 ? { enabled: !0 } : _.export === !1 ? void 0 : _.export, N = ne?.enabled === !0, re = ne?.formats ?? ["csv", "xlsx"], ie = te || M || N && re.length > 0, [ae, oe] = d(v ? y?.initial ?? [] : []), se = _.themeColors, P = _.rowHeight ?? Er[D], ce = _.virtualization === !1 ? void 0 : _.virtualization, F = ce?.enabled === !0, le = l(() => Object.fromEntries(_.columns.filter((e) => e.hide).map((e) => [e.id, !1])), [_.columns]), ue = l(() => {
		let e = [..._.columns.filter((e) => e.pinned === "left").map((e) => e.id), ..._.columnPinning?.left ?? []], t = [..._.columns.filter((e) => e.pinned === "right").map((e) => e.id), ..._.columnPinning?.right ?? []];
		return {
			start: [...new Set(e)],
			end: [...new Set(t)]
		};
	}, [_.columns, _.columnPinning]), [de, fe] = d(ue);
	s(() => {
		fe(ue);
	}, [ue]);
	let [pe, I] = d(() => j === !0 ? null : j?.initial ?? null), L = l(() => Object.fromEntries(_.columns.map((e) => [e.id, e.display ?? "text"])), [_.columns]), R = l(() => M ? Nn(e, pe, L) : e, [
		M,
		e,
		pe,
		L
	]);
	function me(t) {
		I(t), c?.(t), A.publish("table.filterChange", {
			filters: t,
			matchedCount: t ? Nn(e, t, L).length : e.length
		});
	}
	function z(e) {
		let t = {
			columns: _.columns.filter((e) => e.hide !== !0),
			rows: R,
			locale: _.locale,
			currency: _.currency
		}, n = ne?.fileName;
		e === "csv" ? Cr({
			...t,
			fileName: n
		}) : wr({
			...t,
			fileName: n
		}), A.publish("table.export", {
			format: e,
			rowCount: R.length,
			fileName: n ?? "table"
		});
	}
	let B = l(() => C ? Object.fromEntries((r ?? []).map((e) => [e, !0])) : {}, [C, r]), V = ee({
		data: R,
		columns: g.columns,
		manualSorting: b,
		onSortingChange: he,
		enableColumnResizing: E?.enabled !== !1,
		columnResizeMode: "onChange",
		sortDescFirst: !1,
		getRowId: O ? (e) => String(e[O]) : void 0,
		enableRowSelection: C,
		enableColumnPinning: !0,
		onColumnPinningChange: fe,
		state: {
			sorting: ae,
			columnPinning: de,
			columnVisibility: le,
			rowSelection: B
		},
		features: Tr
	});
	function he(e) {
		let t = typeof e == "function" ? e(ae) : e;
		oe(t);
		let n = {
			columnId: t[0]?.id ?? null,
			direction: t[0] ? t[0].desc ? "desc" : "asc" : null,
			sorting: t.map(({ id: e, desc: t }) => ({
				id: e,
				desc: t
			}))
		};
		A.publish("table.sortChange", n), o?.(n.sorting);
	}
	function ge(t, n) {
		if (!C) return;
		let r = String(O ? t[O] : n), a = S?.mode === "multi" ? B[r] ? Object.fromEntries(Object.entries(B).filter(([e]) => e !== r)) : {
			...B,
			[r]: !0
		} : { [r]: !0 }, o = Object.keys(a).filter((e) => a[e]), s = e.filter((e, t) => a[String(O ? e[O] : t)]);
		i?.(o, s), A.publish("table.selectionChange", {
			selectedRows: s,
			selectedIds: o
		});
	}
	function _e(e, t, n) {
		a?.(t, n);
		let r = O ? String(t[O]) : void 0;
		A.publish("table.rowClick", {
			row: t,
			rowIndex: n,
			rowId: r,
			originalEvent: e
		}), ge(t, n);
	}
	function ve(e) {
		if (!T?.enabled || !f) return;
		let t = e.currentTarget, n = T.thresholdPx ?? 200;
		t.scrollHeight - t.scrollTop - t.clientHeight <= n && f();
	}
	let H = _.columns, ye = V.getHeaderGroups(), U = V.getRowModel().rows, be = V.getVisibleLeafColumns().length, W = u(null), G = hn({
		count: U.length,
		getScrollElement: () => W.current,
		estimateSize: () => P ?? 40,
		overscan: ce?.overscan ?? 5
	}), K = F ? G.getVirtualItems() : [], xe = F && K.length > 0 ? K[0].start : 0, Se = F && K.length > 0 ? G.getTotalSize() - K[K.length - 1].end : 0, Ce = F ? K.map((e) => ({
		row: U[e.index],
		index: e.index,
		size: e.size
	})).filter((e) => e.row !== void 0) : U.map((e, t) => ({
		row: e,
		index: t,
		size: P
	})), we = l(() => w?.enabled ? H.map((t) => t.aggregate ? $n(ar(e.map((e) => e[t.id]), t.aggregate), t.display, {
		locale: _.locale,
		currency: _.currency,
		labelFormat: t.labelFormat
	}) : void 0) : null, [
		w?.enabled,
		H,
		e,
		_.locale,
		_.currency
	]);
	return /* @__PURE__ */ p("div", {
		className: $("relative h-full w-full", h),
		style: _n(se),
		children: /* @__PURE__ */ m("div", {
			className: "relative flex h-full w-full flex-col overflow-hidden rounded-md border border-border bg-card",
			children: [
				ie && /* @__PURE__ */ m("div", {
					"data-testid": "table-toolbar",
					className: "relative flex flex-none items-center gap-2 border-b border-border bg-muted/30 px-2 py-1.5",
					children: [
						M && /* @__PURE__ */ p(Vn, {
							locale: k,
							columns: _.columns.map((e) => ({
								id: e.id,
								header: e.header,
								display: e.display
							})),
							filterState: pe ?? vn(),
							onApply: me
						}),
						N && re.includes("csv") && /* @__PURE__ */ p("button", {
							type: "button",
							className: "inline-flex h-8 cursor-pointer items-center gap-1.5 rounded-md border border-input bg-background px-2.5 text-xs font-medium text-foreground hover:bg-accent hover:text-accent-foreground",
							onClick: () => z("csv"),
							"data-testid": "table-export-csv",
							children: Y("exportCsv", k)
						}),
						N && re.includes("xlsx") && /* @__PURE__ */ p("button", {
							type: "button",
							className: "inline-flex h-8 cursor-pointer items-center gap-1.5 rounded-md border border-input bg-background px-2.5 text-xs font-medium text-foreground hover:bg-accent hover:text-accent-foreground",
							onClick: () => z("xlsx"),
							"data-testid": "table-export-xlsx",
							children: Y("exportXlsx", k)
						}),
						te && /* @__PURE__ */ p("div", {
							className: "relative ml-auto",
							children: /* @__PURE__ */ p(Gn, {
								table: V,
								locale: k
							})
						})
					]
				}),
				_.loading && /* @__PURE__ */ m("div", {
					"data-testid": "loading-overlay",
					className: "absolute inset-0 z-50 flex flex-col items-center justify-center bg-background/50 backdrop-blur-sm",
					children: [/* @__PURE__ */ p(dt, { className: "h-8 w-8 animate-spin text-primary" }), /* @__PURE__ */ p("span", {
						className: "mt-4 text-sm font-medium",
						children: _.loadingMessage
					})]
				}),
				n && /* @__PURE__ */ m("div", {
					"data-testid": "loading-more-banner",
					className: "absolute bottom-0 left-0 right-0 z-50 flex flex-row items-center justify-center space-x-2 border-t bg-background/80 p-4 shadow-lg backdrop-blur-sm",
					children: [/* @__PURE__ */ p(dt, { className: "h-4 w-4 animate-spin text-primary" }), /* @__PURE__ */ p("span", {
						className: "text-sm font-medium text-primary",
						children: _.loadingMoreMessage
					})]
				}),
				/* @__PURE__ */ p("div", {
					ref: W,
					className: "gtl-scroll relative min-h-0 flex-1 overflow-auto",
					onScroll: ve,
					children: /* @__PURE__ */ m("table", {
						className: "w-full table-fixed caption-bottom text-sm border-separate border-spacing-0 text-[color:var(--table-cell-text)]",
						style: {
							width: V.getTotalSize(),
							minWidth: "100%"
						},
						children: [
							/* @__PURE__ */ p("thead", {
								className: "gtl-header-styled",
								style: {
									position: "sticky",
									top: 0,
									zIndex: 20
								},
								children: ye.map((e) => /* @__PURE__ */ p("tr", {
									className: "bg-inherit hover:bg-inherit",
									children: e.headers.map((e) => {
										let t = e.column.columnDef.meta?.columnConfig, n = e.column.getIsSorted(), r = ae.findIndex((t) => t.id === e.column.id), i = e.column.getIsPinned(), a = i === "start" && e.column.getIsLastColumn("start"), o = i === "end" && e.column.getIsFirstColumn("end"), s = i === "start" ? e.column.getStart("start") : i === "end" ? e.column.getAfter("end") : void 0;
										return /* @__PURE__ */ m("th", {
											style: {
												width: e.getSize(),
												...Ar(i, s),
												boxShadow: jr(a, o)
											},
											className: $(Or[D], "group whitespace-nowrap border-r border-border/50 border-b border-b-[hsl(var(--border))] text-left align-middle font-medium text-muted-foreground", i ? "gtl-th-pinned" : "bg-inherit"),
											children: [/* @__PURE__ */ m("div", {
												className: $("flex items-center gap-1 whitespace-nowrap", t?.align && kr[t.align], v && t?.sortable !== !1 ? "cursor-pointer select-none" : void 0),
												onClick: v && t?.sortable !== !1 ? e.column.getToggleSortingHandler() : void 0,
												children: [
													x(e.column.columnDef.header, e.getContext()),
													n === "asc" && /* @__PURE__ */ p("span", {
														className: "text-[10px]",
														children: "▲"
													}),
													n === "desc" && /* @__PURE__ */ p("span", {
														className: "text-[10px]",
														children: "▼"
													}),
													n && r >= 0 && /* @__PURE__ */ p("span", {
														className: "rounded bg-muted px-1 py-0.5 text-[10px] font-medium text-muted-foreground",
														"data-testid": `table-sort-index-${e.column.id}`,
														children: r + 1
													})
												]
											}), E?.enabled !== !1 && e.column.getCanResize() && /* @__PURE__ */ p("div", {
												onDoubleClick: () => e.column.resetSize(),
												onMouseDown: e.getResizeHandler(),
												onTouchStart: e.getResizeHandler(),
												className: $("absolute right-0 top-0 h-full w-1 cursor-col-resize select-none touch-none bg-border opacity-0 group-hover:opacity-100", e.column.getIsResizing() && "bg-primary opacity-100")
											})]
										}, e.id);
									})
								}, e.id))
							}),
							/* @__PURE__ */ m("tbody", { children: [
								U.length === 0 && !_.loading && /* @__PURE__ */ p("tr", { children: /* @__PURE__ */ p("td", {
									colSpan: be,
									className: "h-64 text-center text-muted-foreground",
									children: _.emptyMessage
								}) }),
								F && xe > 0 && /* @__PURE__ */ p("tr", { children: /* @__PURE__ */ p("td", {
									style: { height: `${xe}px` },
									colSpan: be
								}) }),
								Ce.map(({ row: e, index: t, size: n }) => /* @__PURE__ */ p("tr", {
									"data-row-id": e.id,
									"data-state": e.getIsSelected() ? "selected" : void 0,
									onClick: (n) => _e(n, e.original, t),
									style: { height: n === void 0 ? void 0 : `${n}px` },
									className: "gtl-row cursor-pointer transition-colors",
									children: e.getVisibleCells().map((n) => {
										let r = n.column.columnDef.meta?.columnConfig, i = n.column.getIsPinned(), a = i === "start" && n.column.getIsLastColumn("start"), o = i === "end" && n.column.getIsFirstColumn("end"), s = i === "start" ? n.column.getStart("start") : i === "end" ? n.column.getAfter("end") : void 0, c = n.getValue();
										return /* @__PURE__ */ p("td", {
											title: typeof c == "string" || typeof c == "number" ? String(c) : void 0,
											style: {
												width: n.column.getSize(),
												...Ar(i, s),
												boxShadow: jr(a, o)
											},
											className: $(Dr[D], "py-0 align-middle whitespace-nowrap border-r border-border/50 border-b border-b-[hsl(var(--border))]", r?.align && kr[r.align], i ? "gtl-td-pinned" : "bg-inherit"),
											children: /* @__PURE__ */ p(Nr, {
												cellValue: n.getValue(),
												columnConfig: r,
												row: e.original,
												rowIndex: t,
												selected: e.getIsSelected(),
												locale: _.locale,
												currency: _.currency
											})
										}, n.id);
									})
								}, e.id)),
								F && Se > 0 && /* @__PURE__ */ p("tr", { children: /* @__PURE__ */ p("td", {
									style: { height: `${Se}px` },
									colSpan: be
								}) })
							] }),
							w?.enabled && /* @__PURE__ */ p("tfoot", {
								style: {
									position: "sticky",
									bottom: 0,
									zIndex: 20
								},
								children: /* @__PURE__ */ p("tr", {
									className: "bg-inherit font-medium hover:bg-inherit",
									children: H.map((e, t) => {
										let n = V.getColumn(e.id), r = n?.getIsPinned(), i = r === "start" && (n?.getIsLastColumn("start") ?? !1), a = r === "end" && (n?.getIsFirstColumn("end") ?? !1), o = r === "start" ? n?.getStart("start") : r === "end" ? n?.getAfter("end") : void 0;
										return /* @__PURE__ */ p("td", {
											style: {
												...Ar(r, o),
												boxShadow: jr(i, a)
											},
											className: $(Dr[D], "py-2 bg-card whitespace-nowrap border-r border-r-[hsl(var(--border))] border-t border-t-[hsl(var(--border))] border-b border-b-[hsl(var(--border))]", e.align && kr[e.align], r && "gtl-td-pinned"),
											children: e.id === w.labelColumnId ? w.label ?? Y("total", k) : we?.[t] ?? ""
										}, e.id);
									})
								})
							})
						]
					})
				})
			]
		})
	});
}
function Nr({ cellValue: e, columnConfig: t, row: n, rowIndex: r, selected: i, locale: a, currency: o }) {
	let s = $n(e, t?.display, {
		locale: a,
		currency: o,
		labelFormat: t?.labelFormat
	});
	if (typeof t?.cellRenderer == "function") {
		let a = t.cellRenderer, o = a({
			value: e,
			displayValue: s,
			row: n,
			rowIndex: r,
			columnId: t.id,
			selected: i
		});
		if (o != null) return Pr(o) ? /* @__PURE__ */ p(Fr, { node: o }) : /* @__PURE__ */ p(f, { children: o });
	}
	if (t?.display === "progress" || t?.display === "progressFull") {
		let n = nr(e), r = typeof t.color == "string" ? t.color : void 0;
		return t.display === "progressFull" ? /* @__PURE__ */ m("div", {
			role: "progressbar",
			"aria-valuenow": Math.round(n),
			"aria-valuemin": 0,
			"aria-valuemax": 100,
			className: "relative -mx-2 flex h-8 items-center overflow-hidden rounded-md bg-muted",
			children: [/* @__PURE__ */ p("div", {
				className: "absolute inset-y-0 left-0 bg-primary transition-[width] duration-300",
				style: {
					width: `${n}%`,
					...r ? { backgroundColor: r } : {}
				}
			}), /* @__PURE__ */ p("span", {
				className: "relative z-10 ml-2.5 rounded-sm bg-black/55 px-1.5 py-0.5 text-xs font-medium tabular-nums text-white",
				children: s
			})]
		}) : /* @__PURE__ */ m("div", {
			className: "flex items-center gap-2",
			children: [/* @__PURE__ */ p("div", {
				className: "h-2 w-full overflow-hidden rounded-full bg-muted",
				children: /* @__PURE__ */ p("div", {
					className: "h-full rounded-full bg-primary transition-[width] duration-300",
					style: {
						width: `${n}%`,
						...r ? { backgroundColor: r } : {}
					}
				})
			}), /* @__PURE__ */ p("span", {
				className: "w-11 shrink-0 text-right text-xs tabular-nums text-muted-foreground",
				children: s
			})]
		});
	}
	if (t?.display === "progressColumn") {
		let n = ir(Number(e), t.columnMax ?? 0), r = typeof t.color == "string" ? t.color : void 0;
		return /* @__PURE__ */ m("div", {
			className: "relative -mx-2 flex h-full min-h-8 items-center overflow-hidden",
			children: [n > 0 && /* @__PURE__ */ p("div", {
				role: "progressbar",
				"aria-valuenow": Math.round(n * 100),
				"aria-valuemin": 0,
				"aria-valuemax": 100,
				className: "absolute inset-y-0 left-0 bg-primary transition-[width] duration-300",
				style: {
					width: `${n * 100}%`,
					...r ? { backgroundColor: r } : {}
				}
			}), /* @__PURE__ */ p("span", {
				className: "relative z-10 flex h-full items-center py-1 pl-2",
				children: /* @__PURE__ */ p("span", {
					className: "inline-flex items-center justify-center rounded-sm bg-black/55 px-1.5 py-0.5 text-xs font-medium tabular-nums text-white",
					children: s
				})
			})]
		});
	}
	return /* @__PURE__ */ p("span", {
		className: "block truncate font-medium",
		children: s
	});
}
function Pr(e) {
	return typeof e == "object" && !!e && "nodeType" in e && typeof e.nodeType == "number";
}
function Fr({ node: e }) {
	let t = u(null);
	return s(() => {
		let n = t.current;
		n && n.replaceChildren(e);
	}, [e]), /* @__PURE__ */ p("span", { ref: t });
}
//#endregion
//#region src/table/import.ts
var Ir = [
	"text",
	"datetime",
	"currency",
	"number",
	"duration",
	"progress",
	"progressFull"
];
function Lr(e) {
	return typeof e == "string" && Ir.includes(e);
}
function Rr(e) {
	return Array.isArray(e) ? e.flatMap((e) => {
		if (typeof e == "string") return [{ key: e }];
		if (e && typeof e == "object" && typeof e.key == "string") {
			let t = e;
			return [{
				key: t.key,
				displayType: t.displayType,
				sizeWidth: t.sizeWidth,
				hide: t.hide,
				color: t.color
			}];
		}
		return [];
	}) : e && typeof e == "object" ? Object.entries(e).map(([e, t]) => ({
		key: e,
		displayType: t
	})) : [];
}
function zr(e) {
	if (!e || typeof e != "object" || Array.isArray(e)) return {};
	let t = e, n = {}, r = Rr(t.columnOrder);
	if (t.columnOrder !== void 0 && t.columnOrder !== null) {
		let e = t.columnPinning?.left ?? [], i = t.columnPinning?.right ?? [];
		n.columns = r.map((t) => {
			let n = {
				id: t.key,
				header: t.key,
				display: Lr(t.displayType) ? t.displayType : "text",
				width: typeof t.sizeWidth == "number" ? t.sizeWidth : 150,
				hide: t.hide === !0 || void 0
			};
			return typeof t.color == "string" && (n.color = t.color), e.includes(t.key) ? n.pinned = "left" : i.includes(t.key) && (n.pinned = "right"), n;
		}), n.columnPinning = {
			left: e.filter((e) => r.some((t) => t.key === e)),
			right: i.filter((e) => r.some((t) => t.key === e))
		};
	}
	return typeof t.rowHeight == "number" && (n.rowHeight = t.rowHeight), typeof t.showFooter == "boolean" && (n.footerTotals = { enabled: t.showFooter }), typeof t.enableVirtualization == "boolean" && (n.virtualization = { enabled: t.enableVirtualization }), t.themeColors !== void 0 && t.themeColors !== null && (n.themeColors = gn(t.themeColors)), n;
}
function Br(e, t) {
	let n = zr(t), r = V(e, n), i = n.columns;
	if (!i) return r;
	let a = new Map(e.columns.map((e) => [e.id, e])), o = new Set(i.map((e) => e.id)), s = [...i.map((e) => {
		let t = a.get(e.id);
		return t ? {
			...t,
			...e,
			header: t.header
		} : e;
	}), ...e.columns.filter((e) => !o.has(e.id))];
	return {
		...r,
		columns: s
	};
}
//#endregion
export { le as AXIS_LABEL_TILT_DEG, R as CALLBACK_KEY, j as CHART_CLEARANCE_GAP, pt as DEFAULT_LIBRARY_LOCALE, Oe as DEFAULT_MAX_EXPORT_HEIGHT, ke as DEFAULT_MAX_EXPORT_PIXELS, De as DEFAULT_MAX_EXPORT_WIDTH, Mr as DataTable, xt as DrillControls, Ke as EChart, ft as LIBRARY_LOCALES, Et as LOAD_MORE_APPLY_DELAY_MS, Dt as LOAD_MORE_LEFT_EDGE_PCT, wt as LOAD_MORE_PRELOAD_BATCHES, Tt as LOAD_MORE_THROTTLE_MS, Ct as LOAD_MORE_WINDOW_SIZE, Mt as anchoredZoomAfterLoad, Nn as applyFilters, Br as applyImportedTableConfig, Lt as buildBarSeries, cr as buildCsv, Bt as buildDataShadowSeries, Nt as buildDataZoomConfig, K as buildEChartOptions, zt as buildLineSeries, He as buildSnapshotOption, Rt as buildSplitBarSeries, Xn as buildTableConfig, _r as buildXlsx, xr as buildXlsxFromGrid, Ge as captureChartSnapshot, H as chartPresets, Fe as computeExportSize, En as countActiveFilters, V as deepMergeConfig, jt as defaultZoom, kn as deserializeFilters, We as downloadDataUrl, St as drillStep, Ue as effectivePixelRatio, vn as emptyFilterState, A as eventBus, Cr as exportTableCsv, wr as exportTableXlsx, rr as formatCompactNumber, $n as formatValue, Cn as getOperatorsForDisplay, Ot as initialLoadedCount, me as isCallbackRef, Q as isRuleComplete, Mn as matchRule, P as measureAxisLabelsBottom, F as measureClearance, ie as measureDataZoomSliderTop, Pe as measureExportLayout, se as measureLegendBottom, ce as measureRequiredGridBottom, he as mergePresets, kt as nextBatchSize, Vt as niceMax, Rr as normalizeColumnOrder, ge as normalizeConfig, zr as normalizeImportedTableConfig, gn as normalizeThemeColors, Tn as operatorIsBetween, wn as operatorNeedsValue, ir as progressByColumnMax, L as registry, pe as resolveAppliedAxisLabelFit, de as resolveAxisLabelFit, z as resolveCallbacks, gt as resolveLocale, Ft as selectedItemStyle, On as serializeFilters, vt as setLibraryMessageProvider, At as sliceLoaded, Ht as stepMax, Y as tLibrary, Jn as tablePresets, _n as themeColorVars, Pt as useChartLoadMore, _e as validateConfig, Ut as zoomCenterPct };

//# sourceMappingURL=echart-table-library.js.map